import tabs from "./tabs.js";
import {table} from "./constants.js";
import smoothHeight from "./smoothHeight.js";
import {alternativeModalSwiper} from "./sliders.js";
import {compareModalSwiper} from "../productPage/productPageSliders.js";
import {
    findVariation,
    getAlternatives,
    getCurrentVariation,
    productItem,
    renderProductGallery,
    renderActiveAttributes,
    renderRatingHTML as renderMainRating, findAttributeValue
} from "../productPage/renderProductInfo.js";
import {getElement, lenghtCorrect, removeActive} from "./helpers.js";
import {
    renderLabelButton, renderButtons, installmentCalc, getVariationFromAttributesMainProduct
} from "../productPage/renderProductInfo.js";
import {productToCart} from "../productPage/productItemPage.js";
import {
    getVariationFromAttributesWithPrice, renderActiveAttributesWithPrice, renderColors

} from "../productPage/productItem.js";
import {openModal} from "./modalFunctions.js";
import {header, productPage} from "./elements.js";
import {fixCompareItemWidth, fixCompareItemHeight} from "../productPage/productPageCompare.js";
import Form from "./Form.js";


class Modal {
    constructor(selector, productItem = {}) {
        this.modal = document.querySelector(selector);
        this.modalBody = this.modal.querySelector(".wrapper");
        this.product = productItem;
        this.isSearch = null;
    }

    openModal(type) {

        if (type == 'search') {

            this.modalBody.parentElement.classList.add('modal-search')
            this.modalBody.innerHTML = searchModal();
            const input = this.modalBody.querySelector('[data-search-input]');
            const searchResult = this.modalBody.querySelector('.search__result');
            const searchPopular = this.modalBody.querySelector('.search__popular');
            const searchTitle = this.modalBody.querySelector('.search__title');
            const searchResultBtn = this.modalBody.querySelector('.search__result-btn');

            let inputText = '';
            this.isSearch = true;
            input.addEventListener('input', () => {
                inputText = input.value;

                if (inputText.length > 3) {
                    searchTitle.innerText = 'Search results'
                    searchPopular.classList.remove('show');
                    searchPopular.classList.add('hide')
                    searchResult.innerHTML = ``
                    const searchItem = search(inputText);

                } else {
                    searchTitle.innerText = 'Popular Search';
                    searchResult.innerHTML = ``
                    searchPopular.classList.add('show');
                    searchPopular.classList.remove('hide')
                    searchResultBtn.classList.remove('show');
                    searchResultBtn.classList.add('hide')
                }

            })

            async function search(query) {
                searchResult.innerHTML = `
                <div class="flex --align-center --just-center loader">
                    <svg class="icon">
                    <use xlink:href="#loader"></use>
                    </svg>
                </div>
                `
                let url = `${ajax_url}?action=uarm_ajax_fast_search&search_query=${query}`
                const response = await fetch(url);
                const result = await response.json();
                const {count, html} = result['products']
                if (count > 0) {
                    let fragment = ''
                    html.forEach(htmlItem => {
                        fragment += htmlItem;
                    })
                    setTimeout(() => {
                        searchResult.innerHTML = fragment;
                        searchResultBtn.classList.remove('hide');
                        searchResultBtn.classList.add('show')
                        searchResultBtn.querySelector('a').href = `${location.hostname}/shop/?s=${query}`;
                    }, 500)


                } else {
                    searchResult.innerHTML = `<div class="search__item">Not found</div>`;
                    if (searchResultBtn.classList.contains('show')) {
                        searchResultBtn.classList.remove('show');
                        searchResultBtn.classList.add('hide')
                    }


                }

            }


        }
        if (type == "reviews" || type == "empty") {

            this.modalBody.innerHTML = reviewModal(type, this.product);
            const {rating: {rating}} = product;
            renderMainRating(this.modalBody.querySelector('.reviews-section__info'), rating);
            document.querySelectorAll('[ data-comment_id]').forEach(item => {
                const idItem = item.dataset.comment_id;

            });

            document.querySelectorAll(".toggle__switch").forEach((item) => {
                item.addEventListener("click", () => {
                    item.classList.toggle("active");
                });
            });

        }
        if (type == "color") {
            this.modalBody.innerHTML = colorModal(this.product);

        }
        if (type == "config") {
            this.modalBody.innerHTML = setupModal(this.product);
            const parentProduct = findProductItem(this.product.dataset[this.product.dataset.subproduct], this.product.dataset.subproduct);

            const currentProduct = findProductItem(this.product.dataset[this.product.dataset.subproduct], this.product.dataset.subproduct).variations.find(el => el.id == +this.product.dataset.productId);
            this.modalBody.querySelector('.product-item__main').dataset.productId = currentProduct.id;
            const {attributes: {allAttributes, variationsAttributes}} = parentProduct
            const renderAttributes = allAttributes.filter(item => {
                for (let key of variationsAttributes) {
                    if (key == Object.keys(item)[0]) {
                        return item;
                    }
                }
            });
            renderVariationsAttributesMain(renderAttributes, parentProduct, this.modalBody);
            const cummerbundSizeAttributeParent = this.modalBody.querySelector('.product-item__cummerbund-size');
            const attributesElements = this.modalBody.querySelector('.product-item__attributes').querySelectorAll('[data-select]');
            renderActiveAttributesWithPrice(attributesElements, currentProduct, currentProduct.price, parentProduct);
            installmentCalc(this.modalBody);
            if (parentProduct.plate) {
                let linkStr = ''
                this.modalBody.querySelector('[data-select="pa_size"]').querySelectorAll('[data-pa_size]').forEach(activeAttr => {
                    if (activeAttr.classList.contains('active')) {
                        linkStr = activeAttr.dataset.pa_size;
                    }
                })
                const div = document.createElement('div')
                parentProduct.plate.forEach(plateItem => {
                    const {name, links} = plateItem;
                    const title = (name[0].toUpperCase() + name.slice(1)).split('_').join(' ')

                    const btns = function () {
                        let fragment = ``;

                        links.forEach((link) => {
                            const {attrName, href, id} = link
                            if (id == parentProduct.productId) {
                                return fragment += `
                  <button class="btn btn--outline  --dir-col active">  <span>${attrName}</span></button>
                `

                            }
                            return fragment += `
                  <a href="${href}?attribute_pa_size=${linkStr}" class="btn btn--outline  --dir-col">  <span>${attrName}</span></a>
                `
                        })
                        return fragment
                    }
                    div.classList = `product-item__${name} product-item--line border--bottom`;
                    div.dataset.plate = true;
                    div.innerHTML = `<div class="flex --just-between  --align-center mb-10"><div class="mr-10">${title}</div></div>
                 <div class="product-item__buttons flex product-item__buttons--height-auto" data-plate>

                  ${btns()}
                  </div>`
                    return div;

                    return div;
                })
                this.modalBody.querySelector('.product-item__size').insertAdjacentElement('beforebegin', div)


            }
            attributesElements.forEach(item => {
                const btns = item.querySelectorAll('button');
                btns.forEach(btn => {
                    btn.addEventListener('click', (e) => {
                        e.stopPropagation()
                        removeActive(btns)
                        btn.classList.add("active");
                        getVariationFromAttributesWithPrice(this.modalBody.querySelector('.product-item__main'), parentProduct)
                        installmentCalc(this.modalBody)
                    });

                })
            });
            if (cummerbundSizeAttributeParent) {
                const sizeAttribute = this.modalBody.querySelector('.product-item__size');
                const cummerbundSizeAttribute = cummerbundSizeAttributeParent.querySelector('[data-select]');
                const switcher = document.createElement('div');
                cummerbundSizeAttribute.classList.add('hide')
                switcher.classList = 'size-switcher flex';
                switcher.innerHTML = `
                    <button class="active" data-switch = 'pa_size'>Vest</button>
                    <button data-switch = 'pa_cummerbund-size'>Cummerbund</button>
                    `;
                switcher.dataset.toggle = 'true';
                sizeAttribute.append(cummerbundSizeAttribute);
                switcher.querySelectorAll('button').forEach(switchBtn => {
                    switchBtn.addEventListener('click', () => {
                        removeActive(switcher.querySelectorAll('button'));
                        switchBtn.classList.add('active')
                        sizeAttribute.querySelectorAll('[data-select]').forEach(item => {
                            item.classList.add('hide')
                            item.classList.remove('show')
                            if (switchBtn.dataset.switch === item.dataset.select) {
                                item.classList.remove('hide')
                                item.classList.add('show')
                            }
                        })

                    })
                })
                sizeAttribute.querySelectorAll('[data-select]').forEach(item => {
                    item.querySelectorAll('button').forEach(btn => {
                        btn.addEventListener('click', () => {
                            if (item.dataset.select === 'pa_size' && switcher.dataset.toggle == 'true') {
                                sizeAttribute.querySelector('[data-select=pa_cummerbund-size]').querySelectorAll('button').forEach(cummerbundBtn => {
                                    if (btn.dataset.pa_size === cummerbundBtn.dataset.pa_cummerbundSize) {
                                        removeActive(sizeAttribute.querySelector('[data-select=pa_cummerbund-size]').querySelectorAll('button'));
                                        cummerbundBtn.classList.add('active');
                                        getVariationFromAttributesWithPrice(this.modalBody, parentProduct)
                                    }
                                })
                            }
                            if (item.dataset.select === 'pa_cummerbund-size') {

                                switcher.dataset.toggle = 'false';

                            }

                        })
                    })
                })
                sizeAttribute.firstElementChild.firstElementChild.insertAdjacentElement('afterend', switcher)
                cummerbundSizeAttributeParent.remove();
            }
            this.modalBody.querySelectorAll("[data-modal]").forEach((btn) => {
                btn.addEventListener("click", () => {
                    openModal(getElement('.modal-overflow'), btn);
                    // modalEvents(getElement(`[data-user-modal="${item.dataset.targetModal}"]`))
                });
            });
            this.modalBody.querySelector('[data-cart]').dataset.text = this.modalBody.querySelector('[data-cart]').innerHTML;
            this.modalBody.querySelector('[data-cart]').addEventListener('click', () => {
                this.modalBody.querySelector('[data-cart]').innerHTML = `<div class="swiper-lazy-preloader"></div>`
                this.modalBody.querySelector('[data-cart]').classList.add('disabled')
                let quantity = this.modalBody.querySelector('[data-product-quantity]').dataset.productQuantity;
                document.dispatchEvent(new CustomEvent('uarm_addToCart', {
                    detail: {
                        id: productToCart(this.modalBody), quantity: +quantity,
                        el: this.modalBody.querySelector('[data-cart]')
                    }
                }));
            })
        }
        if (type.indexOf('size') == 0) {


            this.modalBody.innerHTML = sizeModal(this.product, type.split('_')[1]);
            let sizeObj = {};
            Object.keys(Object.values(table[type.split('_')[1]])[0]).forEach(key => {
                sizeObj[key] = '';
            })

            let isValid = false;
            let isInch = true;
            let attributesObj = {};

            this.modalBody.querySelectorAll('.switcher__item').forEach(switchItem => {
                if (switchItem.classList.contains('active')) {
                    this.modalBody.querySelectorAll('.form__item').forEach(formItem => {
                        formItem.querySelector('label').querySelector('span').innerText = switchItem.innerHTML;

                        if (formItem.querySelector('label').htmlFor == 'height' && switchItem.innerHTML == 'in') {
                            formItem.querySelector('label').querySelector('span').innerText = 'foot'
                        }
                    })
                }

                switchItem.addEventListener('click', () => {
                    removeActive(this.modalBody.querySelectorAll('.switcher__item'));
                    switchItem.classList.add('active');


                    isInch = switchItem.innerText == 'in' ? true : false;
                    this.modalBody.querySelectorAll('.form__item').forEach(formItem => {
                        formItem.querySelector('label').querySelector('span').innerText = switchItem.innerText;
                        if (formItem.querySelector('label').htmlFor == 'height' && switchItem.innerText == 'in') {
                            formItem.querySelector('label').querySelector('span').innerText = 'foot'
                        }
                        formItem.querySelector('input').value = '';
                        let input = formItem.querySelector('input');
                        formItem.querySelectorAll('[data-calc-value]').forEach(span => {
                            if (isInch) {
                                span.innerText = input.name == 'height' ? (+span.dataset.calcValue / 30.48).toFixed(2) : (+span.dataset.calcValue / 2.54).toFixed(2);
                            } else {
                                span.innerText = span.dataset.calcValue;
                            }
                        })

                    })

                    for (let key in sizeObj) {
                        sizeObj[key] = '';
                    }
                    this.modalBody.querySelectorAll('.product-item__buttons').forEach(btnParent => {
                        removeActive(btnParent.querySelectorAll('.btn'));
                    })
                    this.modalBody.querySelector('[data-apply]').classList.add('disabled')

                })
            })

            if (this.modalBody.querySelector('.form__item')) {
                this.modalBody.querySelectorAll('.form__item').forEach(item => {
                    let input = item.querySelector('input')
                    if (input.value.length > 0) {
                        item.classList.add('not-empty')
                    }
                    if (isInch) {
                        item.querySelector('.form__massage').querySelectorAll('span').forEach(span => {
                            span.innerText = input.name == 'height' ? (+span.dataset.calcValue / 30.48).toFixed(2) : (+span.dataset.calcValue / 2.54).toFixed(2);
                        })
                    }
                    input.addEventListener('input', () => {

                        if (input.value.trim().length && input.value.length >= 1) {
                            item.classList.add('not-empty')
                            let itemValue = input.value
                            if (isInch) {
                                itemValue = input.name == 'height' ? +itemValue * 30.48 : +itemValue * 2.54;
                            }
                            sizeObj[`${input.name}`] = isInch ? String(Math.ceil(itemValue)) : itemValue;
                        } else {
                            item.classList.remove('not-empty')
                            if (input.value.length == 1) {
                                item.classList.add('not-empty')
                            }
                            this.modalBody.querySelectorAll('.product-item__buttons').forEach(btnParent => {
                                removeActive(btnParent.querySelectorAll('.btn'));
                            })
                            this.modalBody.querySelector('[data-apply]').classList.add('disabled')
                            sizeObj[`${input.name}`] = '';
                        }
                        let size = {}
                        for (let key in sizeObj) {
                            if (sizeObj[key]) {
                                isValid = true
                            } else {
                                isValid = false
                            }
                        }

                        if (isValid) {
                            if (type.split('_')[1] == 'bodySize' || type.split('_')[1] == 'vestBodySize') {
                                let obj = table[type.split('_')[1]];
                                obj.set.forEach(item => {
                                    let name = item.split(`${type.split(`_`)[1]}`)[1].toLowerCase()
                                    let value = findProductSize(sizeObj, table[item])
                                    if (value) {

                                        size[name] = value.slice(0, -1)

                                    }
                                })
                            } else {
                                let value = findProductSize(sizeObj, table[type.split('_')[1]]);

                                if (value) {
                                    size.size = value
                                    if (type === 'size_panelSize' || type === 'size_plateSize') {
                                        size.size = value.slice(0, -1)
                                    }
                                }
                            }
                        }

                        for (let key in size) {
                            if (!size[key]) return
                            this.modalBody.querySelector(`[data-type="${key}"]`).querySelectorAll('.btn').forEach((btn) => {
                                if (size[key].toLowerCase() == btn.dataset.pa_size) {
                                    removeActive(this.modalBody.querySelector(`[data-type="${key}"]`).querySelectorAll('.btn'));
                                    btn.classList.add('active');
                                    attributesObj[`${this.modalBody.querySelector(`[data-type="${key}"]`).dataset.type}`] = size[key].toLowerCase();
                                    this.modalBody.querySelector('[data-apply]').classList.remove('disabled')
                                    return
                                }

                            })

                        }


                    })

                })
            }
            this.modalBody.querySelector('[data-apply]').addEventListener('click', () => {
                this.modalBody.querySelectorAll('[data-type]').forEach(sizeParent => {
                    productItem.querySelectorAll(`[data-size-type="${sizeParent.dataset.type}"]`).forEach(sizeItem => {
                        sizeItem.querySelectorAll('.btn').forEach(btn => {
                            switch (sizeItem.dataset.sizeType) {
                                case 'cummerbund':
                                    if (btn.getAttribute('data-pa_cummerbund-size') == attributesObj[sizeItem.dataset.sizeType]) {
                                        removeActive(sizeItem.querySelectorAll('.btn'));
                                        productItem.querySelector('.size-switcher').dataset.toggle = "false";
                                        return btn.classList.add('active')
                                    }
                                    break

                                default:
                                    if (btn.dataset.pa_size == attributesObj[sizeItem.dataset.sizeType]) {
                                        removeActive(sizeItem.querySelectorAll('.btn'));
                                        return btn.classList.add('active')
                                    }
                                    break

                            }
                            getVariationFromAttributesMainProduct(productItem.querySelector('.product-item__attributes').querySelectorAll('[data-select]'));
                            this.closeModal()
                        })
                    })
                })


            })

            // document.querySelectorAll('[data-input="label"]').forEach((item) => {
            //     focusWithLabel(item);
            // });
        }
        if (type == "protection level" || type == "protection helmet") {

            if (matchMedia("(max-width: 767px)").matches) {
                this.modalBody.innerHTML = protectionModalMobile(type, this.product);
                smoothHeight(".modal-protection__item", "[data-protect-smooth]", ".modal-protection__item-wrapper");
            } else {
                this.modalBody.innerHTML = protectionModal(type, this.product);
            }
            protectionModalEvents();


        }
        if (type == "configuration") {
            this.modalBody.innerHTML = configurationModal();
        }
        if (type == "setup") {
            this.modalBody.innerHTML = configurationModal();

        }
        if (type == "alternatives") {
            this.modalBody.innerHTML = alternativesModal(product);
            alternativeModalSwiper("alternative-modal");
            const fixHeight = () => {
                let items = []
                this.modalBody.querySelectorAll('.compare-item').forEach((compareItem) => {
                    let obj = {};
                    compareItem.querySelectorAll('.h2').forEach((item, i) => {
                        obj[i] = item.scrollHeight;

                    })
                    items = [obj, ...items]
                })

                let val = items[0]
                items.forEach(item => {
                    for (let key in item) {
                        if (val[key] < item[key]) {
                            val[key] = item[key]
                        }
                    }

                })

                this.modalBody.querySelectorAll('.compare-item').forEach(compareItem => {
                    compareItem.querySelectorAll('.h2').forEach((item, i) => {
                        compareItem.querySelectorAll('.h2')[i].style.height = `${val[i]}px`
                    })
                })
            }
            this.modalBody.querySelectorAll('[data-choose-alternative]').forEach(chooseBtn => {
                chooseBtn.addEventListener('click', () => {

                    const attributesElements = productItem.querySelector('.product-item__attributes').querySelectorAll('[data-select]');
                    let alternativeVariation = null
                    if (product.plate) {
                        let variations = {};
                        product.plate.forEach(plateItem => {
                            variations = plateItem.links.find(el => el.id == product.productId).variations;
                        })
                        alternativeVariation = variations.find(variation => variation.id == chooseBtn.parentElement.dataset.alternativeId);
                    } else {
                        alternativeVariation = product.variations.find(el => el.id == chooseBtn.parentElement.dataset.alternativeId);
                    }
                    let newPrice = +alternativeVariation.price !== +alternativeVariation.regular_price ? alternativeVariation.price : alternativeVariation.regular_price;
                    attributesElements.forEach(item => {
                        const btns = item.querySelectorAll('button');
                        installmentCalc(productItem);
                        btns.forEach(btn => {
                            removeActive(btns)
                            renderActiveAttributes(attributesElements, alternativeVariation, newPrice);
                            getVariationFromAttributesMainProduct(attributesElements);
                            if (btn.dataset.pa_color && btn.classList.contains('active')) {
                                const productInformation = getElement('.product-item__information');
                                const productImages = productInformation.querySelector('.product-item__gallery ').querySelector('.photos');
                                productImages.innerHTML = '';
                                productImages.appendChild(renderProductGallery(btn.dataset.pa_color, productImages))

                            }
                        })
                    });
                    this.closeModal()

                })
            })

            fixHeight()
            fixCompareItemWidth(this.modalBody);


            // window.addEventListener("resize", () => {
            //     setTimeout(() => {
            //         fixCompareItemWidth(this.modalBody);
            //         fixHeight()
            //     }, 350)
            // });

        }
        if (type == "gallery") {
            this.modalBody.innerHTML = galleryModal();
            tabs('[data-tabs="galerry"]', ".tabs__nav", ".tabs__body", ".tabs__btn", "active", "show");
        }
        if (type == "tech") {
            this.modalBody.innerHTML = techModal(product);
            if (matchMedia("(max-width: 767px)").matches) {
                smoothHeight(".table-item", ".table-item__header", ".table-item__content");
            }
            tabs('[data-tabs="tech"]', ".tabs__nav", ".tabs__body", ".tabs__btn", "active", "show");
            techTableEvents(this.modalBody)
        }
        if (type == "compare" || type == "compare-catalog") {
            // this.modalBody.classList.remove('modal__content')

            if (type == "compare") {
                this.modalBody.innerHTML = compareModal();
            } else {
                this.modalBody.innerHTML = compareModalCatalog();
            }
            this.modalBody.querySelector('.compare-section').style.height = `calc(100vh - ${this.modalBody.querySelector('.compare-section').offsetTop + this.modalBody.offsetTop}px)`
            compareModalSwiper();

            fixCompareItemWidth(this.modalBody);
            fixCompareItemHeight(this.modalBody)
            window.addEventListener('resize', () => {
                setTimeout(() => {

                    fixCompareItemWidth(this.modalBody);
                    fixCompareItemHeight(this.modalBody)
                }, 350)
            })
            // this.modalBody.querySelectorAll('.compare-item__content-scroll').forEach(compareItem => {
            //     compareItem.addEventListener("scroll", () => {
            //         let scroll = compareItem.scrollTop;
            //         clearTimeout(this.modalBody.querySelectorAll('.compare-item__content-scroll').forEach(item => {
            //             if (item !== compareItem) {
            //                 item.scrollTop = scroll;
            //             }
            //         }))
            //     });
            // })
        }
        if (type === 'report') {
            this.modalBody.innerHTML = renderReportModal();
            new Form('.report-form').reportForm();
        }

        this.adaptiveScrollHeight();
        if (header.classList.contains('active') && type == 'search') {
            header.classList.remove('active')
            getElement('.navigation__menu').classList.remove('active')
            removeActive(header.querySelectorAll('.navigation__item'));
            let submenuItemActive = header.querySelector('.submenu__wrapper.show');
            submenuItemActive.classList.remove('show')
            submenuItemActive.classList.add('hide')
        }

        this.modal.classList.add("show");

        this.modal.classList.remove("hide");
        document.body.classList.add("active");
        this.attachModalEvents(this.modal);
        if (type !== 'config') {
            this.modalBody.querySelectorAll('[data-cart]').forEach(cartBtn => {
                cartBtn.dataset.text = cartBtn.innerHTML;
                cartBtn.addEventListener('click', () => {
                    cartBtn.innerHTML = `<div class="swiper-lazy-preloader"></div>`
                    cartBtn.classList.add('disabled')
                    let quantity = productPage.querySelector('[data-product-quantity]').dataset.productQuantity
                    document.dispatchEvent(new CustomEvent('uarm_addToCart', {
                        detail: {
                            id: productToCart(productPage), quantity: +quantity, el: cartBtn
                        }
                    }));
                })
            })
        }
    }

    attachModalEvents() {
        if (this.modal.querySelector('[data-close]')) {
            this.modal
                .querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener("click", () => {
                    this.closeModal(this.modal);
                });


            })

        }

        document.addEventListener("keydown", (e) => {
            this.handleEscape(e);
        });
        this.modal.addEventListener("click", (e) => {
            this.handleOutside(e);
        });
    }

    closeModal() {
        this.modal.classList = this.isSearch ? "modal modal-search" : "modal";

        setTimeout(() => {
            this.modal.classList.add("hide");
            this.modal.classList.remove("show");
            document.body.classList.remove("active");
        }, 0);

        if (this.isSearch) {

            setTimeout(() => {
                this.isSearch = null;
                this.modal.classList.remove('modal-search')
            }, 500)

        }


        this.detachModalEvents(this.modal);

        setTimeout(() => {
            this.modalBody.innerHTML = ``;
        }, 250);

    }

    detachModalEvents() {
        if (this.modal.querySelector('[data-close]')) {
            this.modal
                .querySelectorAll('[data-close]').forEach(item => {
                item.removeEventListener("click", () => {
                    this.closeModal(this.modal);
                });
            })


        }
        document.removeEventListener("keydown", (e) => {
            this.handleEscape(e);
        });
        this.modal.removeEventListener("click", (e) => {
            this.handleOutside(e);
        });
    }

    handleEscape(event) {
        if (event.key === "Escape") {
            this.closeModal(this.modal);
        }
    }

    handleOutside(event) {
        const isClickOutside = !!event.target.closest(".modal__body");
        if (!isClickOutside) {
            this.closeModal(this.modal);
        }
    }

    adaptiveScrollHeight() {

        const modalContent = this.modal.querySelectorAll(".modal__content");
        if (!modalContent) return;
        modalContent.forEach(item => {

            adaptiveModalContent(item);
        })

        window.addEventListener("resize", () => {
            modalContent.forEach(item => {
                adaptiveModalContent(item);
            })
        });
    }
}

function renderSystemItemsValue(parent) {
    parent.querySelectorAll('.tabs__content').forEach(tabItem => {
        tabItem.querySelectorAll('.switcher__item').forEach(item => {
            if (item.classList.contains('active')) {
                tabItem.querySelectorAll('[data-system-item]').forEach(cellItem => {
                    if (+cellItem.firstElementChild.innerHTML) {
                        cellItem.lastElementChild.innerHTML = item.getAttribute(`data-${item.dataset.system}`)
                    }
                    if (cellItem.firstElementChild.innerHTML.indexOf('-') > 0 || cellItem.firstElementChild.innerHTML.indexOf(' x ') > 0) {
                        cellItem.lastElementChild.innerHTML = item.getAttribute(`data-${item.dataset.system}`)
                    }

                })
            }
        })
    })
}

function techTableEvents(parent) {
    renderSystemItemsValue(parent);
    parent.querySelectorAll('.tabs__content', true).forEach(tabItem => {

        tabItem.querySelectorAll('.switcher__item').forEach(item => {

            item.addEventListener('click', () => {
                removeActive(tabItem.querySelectorAll('.switcher__item'));
                item.classList.add('active')
                tabItem.querySelectorAll('[data-system-item]').forEach(cellItem => {
                    if (+cellItem.firstElementChild.innerHTML) {
                        cellItem.lastElementChild.innerHTML = item.getAttribute(`data-${item.dataset.system}`)
                        let number = cellItem.firstElementChild.innerHTML;
                        cellItem.firstElementChild.innerHTML = calcValues(item.getAttribute(`data-${item.dataset.system}`), number)

                    } else {
                        if (cellItem.firstElementChild.innerHTML.indexOf(' - ') > 0) {
                            let newValues = [];
                            cellItem.lastElementChild.innerHTML = item.getAttribute(`data-${item.dataset.system}`)
                            cellItem.firstElementChild.innerHTML.split(' - ').forEach(el => {
                                newValues = [...newValues, calcValues(item.getAttribute(`data-${item.dataset.system}`), el)]
                            })
                            cellItem.firstElementChild.innerHTML = newValues.join(' - ')
                        }
                        if (cellItem.firstElementChild.innerHTML.indexOf(' x ') > 0) {
                            let newValues = [];
                            cellItem.lastElementChild.innerHTML = item.getAttribute(`data-${item.dataset.system}`)
                            cellItem.firstElementChild.innerHTML.split(' x ').forEach(el => {
                                newValues = [...newValues, calcValues(item.getAttribute(`data-${item.dataset.system}`), el)]
                            })
                            cellItem.firstElementChild.innerHTML = newValues.join(' x ')
                        }
                    }

                })
            })

        })
    })


}

function calcValues(value, number) {
    switch (value) {
        case 'kg':
            return String((+number / 2.205).toFixed(2));

        case 'lbs':
            return String((+number * 2.205).toFixed(1));

        case 'cm²':
            return String(Math.round(+number * 6.45));

        case 'in²':
            return String(Math.round(+number / 6.45));

        case '”':
            return String((+number / 25.5).toFixed(2));

        case 'in':
            return String((+number / 2.54).toFixed(1));

        case 'mm':
            return String(Math.round(+number * 25.5));

        case 'cm':
            return String(Math.round(+number * 2.54));
        case 'kg/m²':
            return String((+number / 23.73).toFixed(1));
        case 'lb/ft²':
            return String((+number * 23.73).toFixed(2));

        default:
            return;
    }
}

function adaptiveModalContent(el) {


    if (el) {
        const footer = document.querySelector(".modal__footer");
        let offset;

        if (matchMedia("(max-width: 767px)").matches) {
            offset = footer ? footer.clientHeight + 25 : 25;
            return (el.style.height = `calc(100vh - ${el.offsetTop + offset}px`);
        } else {
            offset = footer ? footer.clientHeight : 5;
            return (el.style.height = `calc(100vh - ${el.offsetTop + offset}px`);
        }


    }
}

function searchModal() {
    return `<div class="search modal__body">
<div class="container h-100">
    <div class="search__header  flex ">
        <div class="wrapper  --align-center">
            <div class="col col-1 desktop-1 tablet-1 wide-1">
               <div class="flex-inline"> <a class="logo">
                    <svg class="icon">
                        <use xlink:href="#logo"></use>
                    </svg>
                </a></div>
            </div>
            <div class="col tablet-2 desktop-4 wide-5">
                <form action="/shop/" class="search__form">

                    <div class="search__form-item flex pos-r">
                    <button type="submit"><span class="icon-search icon-20 mr-10"></span></button>
                         
                        <input type="text" name="s" placeholder="Search..." class="search__input w-100" data-search-input  autofocus>
                    </div>


                </form>
       
                
            </div>
            <div class="col col-1 desktop-1 tablet-1 wide-1">
                <button class="close-button flex --align-center --just-center ml-auto" data-close>
          <span>
              <svg class="icon">
              <use xlink:href="#close"></use>
          </svg>
          </span>

                </button>
            </div>
        </div>
    </div>
   
 
    <div class="wrapper --just-center search__content-wrapper">
    <div class="col tablet-4 desktop-4 wide-6 pos-r">
    <div class="search__title text-color__black--60 txt--1 mb-10 ">
            Popular Search
        </div>
   <div class="search__content">
   <div class="search__popular ">  <a href="/product/fas-full-armor-system/" class="search__item flex --align-center text-color__black txt-no-underline">
       <div class="preview image br--6 ">
                  <img src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_8987-Edit-3-1.png" alt="AS™ Full Armor System">
                </div>
                <h2>FAS™ Full Armor System</h2>
        </a></div>
      <div class="search__result">
       
    </div>
    <div class="search__result-btn txt-center mt-20 hide">
    <a href="#" class="btn btn--outline flex-inline text-upper px-20">View all<span class="text-color__black--60"></span></a>
</div>
     

    </div>
    </div>
    
</div>

</div>
</div>`
}

function productHeader(productItem) {
    if (!productItem) return ` <div class="modal__header mb-20 flex --align-center border--bottom border-black">
                <button class="modal__close btn btn--outline" data-close>
                  Close
                </button>
          
        
          </div>`;

    const title = productItem.querySelector('[data-product-title]').innerText;
    const price = productItem.querySelector('[data-product-price]').innerText;
    const thumbnail = productItem.dataset.productThumbnail
    return `
              <div class="modal__header mb-20 flex --align-center border--bottom border-black">
                <button class="modal__close" data-close>
                  <svg class="icon">
                    <use xlink:href="#arrow"></use>
                  </svg>
                </button>
                <div class="preview image br--6 ">
                  <img src="${thumbnail}" alt="">
                </div>
            
                <h2>${title}</h2>
            
                <div class="price h2 fw-600 mr-10">${price}</div>
                <button class="btn btn--outline" data-cart>Add to bag</button>
        
          </div>
    `

}

function renderReviewItem() {
    const {comments} = product;
    let fragment = '';
    ;

    comments.forEach(item => {
        const {author, comment_date, comment, rating, id} = item;
        fragment += `
          <div class="item" data-comment_id="${id}">
               <div class="stars mb-10  flex" data-stars="${rating}">
${renderRatingHTML(rating)}
              

      </div>
              <div class="h2 fw-600 mb-5">
               ${author}
              </div>
              <div class="text-color__black--60 mb-10 h5"> ${comment_date}</div>


              <div>   ${lenghtCorrect(comment, 300)}</div>

            </div>
        `

    })
    return fragment;

}

function reviewsEmpty() {
    return `
    <div class="reviews-section product-item-grid">
    <div class="reviews-section__info">
      <h2 class="h1 mb-20">Reviews </h2>
    </div>
    <div class="reviews-section__empty h-100">


      <div class="bgc--black-5 br--16 flex --align-center --just-center h-100 w-100">
        <div class="box">
          <h2 class="h1 mb-10">There are no reviews yet. Be the first to make a review.</h2>
          <div class="mb-20">You should have a delivered order first in order to make a review.</div>
          <button class="btn btn--black">
            Add review
          </button>
        </div>
      </div>
    </div>
  </div>`
}

function renderRatingHTML(average) {
    let fragment = '';
    let arr = [1, 2, 3, 4, 5]
    let newArr = []
    for (let j = 1; j <= Math.trunc(average); j++) {
        if (arr[j - 1] == j) {
            fragment += `
          <span class="star">
             <svg class="icon" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.912 3L17.5864 11.231H26.241L19.2393 16.318L21.9137 24.549L14.912 19.462L7.91031 24.549L10.5847 16.318L3.58302 11.231H12.2376L14.912 3Z" fill="#111111"/>
             </svg>
           </span>
        `;
            newArr = ['full', ...newArr]
        }
    }
    if (!Number.isInteger(average)) {

        newArr = [...newArr, 'hulf']
        fragment += `              <span class="star">
                 <svg class="icon"viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.912 3L17.5864 11.231H26.241L19.2393 16.318L21.9137 24.549L14.912 19.462L7.91031 24.549L10.5847 16.318L3.58302 11.231H12.2376L14.912 3Z" fill="#000" fill-opacity="0.4"/>
                    <path d="M7.90932 24.549L14.911 19.462V3L12.2366 11.231H3.58203L10.5837 16.318L7.90932 24.549Z" fill="#111111"/>
               </svg>
               </span>`;
    }
    if (newArr.length < 5) {
        for (let i = 1; i <= arr.length; i++) {
            if (!newArr[i - 1]) {
                newArr = [...newArr, 'empty'];
                fragment += `
          <span class="star empty">
             <svg class="icon" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.912 3L17.5864 11.231H26.241L19.2393 16.318L21.9137 24.549L14.912 19.462L7.91031 24.549L10.5847 16.318L3.58302 11.231H12.2376L14.912 3Z" fill="#111111"/>
             </svg>
           </span>
        `;
            }
        }
    }
    return fragment;
}

function reviews() {
    const {comments, rating: {rating}} = product;
    return `
    <div class="reviews-section product-item-grid">
    <div class="reviews-section__info">
      <h2 class="h1 mb-20">Reviews <span class="text-color__black--60">${comments.length}</span></h2>
      <div class="stars flex">

        <span class="star empty">
          <svg class="icon" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.912 3L17.5864 11.231H26.241L19.2393 16.318L21.9137 24.549L14.912 19.462L7.91031 24.549L10.5847 16.318L3.58302 11.231H12.2376L14.912 3Z" fill="#111111"/>
                          </svg>
        </span>
             
        </span>


      </div>
      <div class="rating text-color__black--60 mb-20">
        Overall rating: <span class="text-color__black">${rating} of 5</span>
      </div>
      <div class="reviews-section__btns flex modal__footer">
        <button class="btn btn--outline">Back to shopping</button><button class="btn btn--black">Add review</button>
      </div>
    </div>
    <div>
<!--      <div class="reviews-section__toggle  mb-20 border&#45;&#45;bottom flex">-->
<!--        <div class="toggle flex &#45;&#45;align-center">-->
<!--          <div class="toggle__switch mr-10">-->
<!--            <span></span>-->
<!--          </div>-->
<!--          <div class="h3 fw-600">Show military reviews only</div>-->
<!--        </div>-->
<!--        <div class="toggle  flex &#45;&#45;align-center">-->
<!--          <div class="toggle__switch  mr-10">-->
<!--            <span></span>-->
<!--          </div>-->
<!--          <div class="h3 fw-600">Show military reviews only</div>-->
<!--        </div>-->
<!--      </div>-->
      <div class="modal__content">
        <div>
          <div class="reviews-section__content">

           ${renderReviewItem()}
          </div>
        </div>
      </div>

    </div>
  </div>`
}

function reviewModal(type, productItem) {


    return `
      <div class="col desktop-5 wide-6 modal__body  pos-r">
        <div class="modal-reviews">
          ${productHeader(productItem)}
          ${type === 'reviews' ? reviews() : reviewsEmpty()}
          

        </div>
      </div>
`;


}

function colorModal(productItem) {

    return `
  <div class="col tablet-3 desktop-2 wide-3 modal__body ">
<div class="modal-color">

    ${productHeader(productItem)}
  <div class="modal__content">
   ${renderModalColorItem(productItem)}
  </div>
</div></div>`;
}

function renderModalColorItem(productItem) {
    const colors = {
        multicam: {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/images/colorsImages/multicam.png',
            descr: 'Multicam is a camouflage pattern developed by the American company Crye Precision, in conjunction with the United States Army. Designed to provide effective concealment in a wide range of environments, this iconic pattern is utilized by civilian and military forces around the world.',
            name: 'Multicam®'
        }, black: {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/css/../images/colorsImages/black.png',
            descr: 'Black – this stylish and discrete shade is utilized by special forces and law enforcement operating in urban environments.  We don\'t recommend black for use in outdoor environments – providing ineffective concealment during day and night alike.',
            name: 'Black'
        },

        coyote: {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/css/../images/colorsImages/coyote.png',
            descr: 'Coyote – among the oldest, and most iconic camouflage solutions. Rumored to have been first utilized by native Americans, who wore coyote skins for disguise, this camo option is as old as modern warfare itself. Mimicking nature, coyote imitates clay, dirt and light foliage. Available in dark Coyote Brown, and light Coyote Tan, this camo solution offers serious concealment, in a wide range of environments.',
            name: 'Coyote'
        }, ranger_green: {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/css/../images/colorsImages/green.png',
            descr: 'Ranger Green – our most popular camouflage option. Tried and tested by the US Army Rangers, this shade offers classic camouflage for serious concealments in wooded landscapes. Utilizing a \'grey\' shade of green, Ranger Green is considered to provide superficial concealment to brighter alternative patterns.',
            name: 'Ranger Green'
        }, 'navy-blue': {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/css/../images/colorsImages/navy.png',
            descr: 'Navy Blue - the tone of dark blue, which got its name from color worn by officers in the British Royal Navy since 1748 and subsequently adopted by other navies around the world. Nowadays, in many world navies, “navy blue” uniforms are, in actuality, colored black, as the uniforms became darker to counter fading.',
            name: 'Navy Blue'
        }, tan: {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/css/../images/colorsImages/tan.png',
            descr: 'Tan - a pale tone of brown. The name is derived from the process by which animal hide becomes leather (tanning). The process owes its name to an old German name of oak trees - tannin and chemical compound tannum, used in it.',
            name: 'Tan'
        }, beige: {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/css/../images/colorsImages/beige.png',
            descr: 'Tan - a pale tone of brown. The name is derived from the process by which animal hide becomes leather (tanning). The process owes its name to an old German name of oak trees - tannin and chemical compound tannum, used in it.',
            name: 'Beige'
        }, laser: {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/css/../images/colorsImages/laser.png',
            descr: 'Tan - a pale tone of brown. The name is derived from the process by which animal hide becomes leather (tanning). The process owes its name to an old German name of oak trees - tannin and chemical compound tannum, used in it.',
            name: 'Laser'
        }, red: {
            img: 'https://uarmprotection.com/wp-content/themes/uarm/css/../images/colorsImages/red.png',
            descr: 'Tan - a pale tone of brown. The name is derived from the process by which animal hide becomes leather (tanning). The process owes its name to an old German name of oak trees - tannin and chemical compound tannum, used in it.',
            name: 'Red'
        },

        default: {
            descr: 'While not a color or pattern, our Civil Camoflague designs disguise tactical garments to look like standard clothing – helping you blend into the crowd.'
        }

    }
    let fragment = '';
    productItem.querySelectorAll('[data-pa_color]').forEach(item => {


        if (colors[item.dataset.pa_color]) {

            const {img, name, descr} = colors[item.dataset.pa_color]
            return fragment += `
        <div class="modal-color__item border--bottom">
      <div class="image image-modal  br--16 mb-20"><img src="${img}" alt="${name}">
      </div>
      <div class="h1 fw-600 mb-10">
        ${name}
      </div>
      <p>${descr}</p>
    </div>
        `
        } else {
            const {descr} = colors.default
            return fragment += `
        <div class="modal-color__item border--bottom">
      <div class="image image-modal  br--16 mb-20">
      </div>
      <div class="h1 fw-600 mb-10">
        ${item.querySelector('img').alt}
      </div>
      <p>${descr}</p>
    </div>
        `
        }


    })

    return fragment;
}

function findProductSize(sizeObj, modalType) {

    return Object.keys(modalType).find(el => {
        for (let key in modalType[el]) {

            return Object.keys({...modalType[el], ...sizeObj}).every(key => {

                if (sizeObj[key] && sizeObj[key] >= modalType[el][key][0] && sizeObj[key] <= modalType[el][key][1]) {
                    return el;
                }
            })
        }
    })
}

function sizeModal(productItem, type) {

    const {attributes: {allAttributes}} = product;
    let {attrName, values,} = Object.values(allAttributes.find(attr => {
        return Object.keys(attr).find((el => {
            if (el == 'pa_size') {
                return attr;
            }
        }))
    }))[0];
    const modalType = table[type];

    let popup = '';
    switch (type) {
        case 'vestBodySizeWithoutCummerband':
            popup = 'popup-height'
            break;
        case   'femaleVestBodySizeWithoutCummerband':
            popup = 'popup-height'
            break;
        case   'apparelTopSize':
            popup = 'popup-height'
            break;
        case   'femaleApparelTopSize':
            popup = 'popup-height'
            break;
        case   'beltSize':
            popup = 'popup-chest'
            break;
        case   'bodySize':
            popup = 'popup-chest'
            break;
        case   'bodySizeWithoutCummerband':
            popup = 'popup-chest'
            break;
        case   'vestBodySize':
            popup = 'popup-chest'
            break;
        case   'femaleVestBodySize':
            popup = 'popup-chest'
            break;
        case   'bodySizeVest':
            popup = 'popup-chest'
            break;
        case   'bodySizeCummerbund':
            popup = 'popup-chest'
            break;
        case   'vestBodySizeVest':
            popup = 'popup-chest'
            break;
        case   'vestBodySizeCummerband':
            popup = 'popup-chest'
            break;
        case   'femaleVestBodySizeCummerband':
            popup = 'popup-chest'
            break;
        case   'femaleVestBodySizeVest':
            popup = 'popup-chest'
            break;
        case   'headSize':
            popup = 'popup-helmet'
            break;
        case   'canineBodySize':
            popup = 'popup-dog'
            break;
        case   'panelSize':
            popup = 'popup-chest'
            break;
        default:
            popup = '';
            break
    }


    return `
<div class="col tablet-3 desktop-2 wide-3 modal__body ">
  <div class="modal-size">
   ${productHeader(productItem)}
    <div class="modal__content">
      <div class="modal-size__header mb-20 pos-r br--16 image-modal ">
        <div class="image ">
        <div class="img fit--contain ${popup}"></div>
        
        </div>
        <div class="switcher switcher--s switcher--white flex pos-a br--6 ">
          <button class="switcher__item h3 fw-600 text-color__white active" >in</button>
          <button class="switcher__item h3 fw-600 text-color__white ">cm</button>
        </div>
        <button class="flex --align-center product-item__modal-triger none ">
          <span>Size chart</span>

            <span class="icon-arrow-right icon-12"></span>
        
        </button>
      </div>
      <div class="h1 fw-600 mb-20">
        Size Calculator
      </div>
      <div class="modal-size__inputs flex --just-between border--bottom mb-20"> 
        ${renderSizeInputs(modalType)}
      </div>
          ${renderSizeButtons(type, attrName, values)}
    </div>
    <div class="modal__footer shadow--up flex --align-center --just-between">
      <button class="btn btn--outline" data-close>Cancel</button>
      <button class="btn btn--black disabled" data-apply>Apply</button>
    </div>
  </div>
</div>
`;


}

function renderSizeInputs(modalType) {
    let itemValues = null
    let fragment = '';
    let values = [];
    for (let item in modalType) {
        if (item !== 'set') {
            itemValues = [...Object.keys(modalType[item])]
            for (let key in modalType[item]) {
                if (values[key]) {
                    values[key] = [...values[key], ...modalType[item][key]]
                } else {
                    values[key] = [...values, ...modalType[item][key]]
                }
            }
        }
    }


    itemValues.forEach(value => {
        let title = value[0].toUpperCase() + value.slice(1)
        if (value.match(/_/)) {
            title = value.split('_').join(' ');
            title = title[0].toUpperCase() + title.slice(1)
        }
        fragment += `
        <div class="form__item">
            <input type="number" id="${value}" name="${value}">
                <label for="${value}">${title}, <span>cm</span></label>
                <div class="form__massage">from <span data-calc-value="${Math.min(...values[value])}">${Math.min(...values[value])}</span> to <span data-calc-value="${Math.max(...values[value])}">${Math.max(...values[value])}</span></div>
        </div>`


    })
    return fragment;

}

function renderSizeButton(attrName, values) {
    let fragment = ""

    values.forEach(item => {
        let {slug, value} = item;
        fragment += `<button class="btn btn--outline "  data-${attrName}="${slug}">${value}</button>`
    })
    return fragment;
}

function renderSizeButtons(type, attrName, values) {
    const modalType = table[type];
    let fragment = '';
    if (modalType.set) {
        modalType.set.forEach(item => {
            fragment += `
                <div class="modal-size__info" data-type="${item.split(type)[1].toLowerCase()}" data-size>
                    <div class="mb-10">${item.split(type)[1]}</div>
                    <div class="product-item__buttons flex --align-center mb-20">
                        ${renderSizeButton(attrName, values, item.split(type)[1])}
                    </div>
                </div>
            `
        })


    } else {
        fragment = `
                <div class="modal-size__info" data-type="size">
                    <div class="mb-10">Size</div>
                    <div class="product-item__buttons flex --align-center mb-20">
                        ${renderSizeButton(attrName, values, type)}
                    </div>
                </div>
            `
    }
    return fragment

}


function protectionModal(type, productItem) {

    return `
  <div class="col desktop-5 wide-6 modal__body ">
<div class="modal-protection flex --dir-col h-100">
  <div class="col">
    
  ${productHeader(productItem)}
  </div>
  ${type == "protection level" ? protectionAll() : protectionHelmet()};
</div>
</div>`;

}

function protectionModalEvents() {
    getElement('.switcher__item', true).forEach(item => {
        item.addEventListener('click', () => {
            getElement(`.${item.dataset.system}`, true).forEach(el => {
                for (let element of el.parentNode.children) {
                    element.classList.add('hide')
                }
                el.classList.remove('hide')
            })
            removeActive(getElement('.switcher__item', true));
            item.classList.add('active')
        })
    })
}

function protectionModalMobile(type, productItem) {
    return `
  <div class="col modal__body">
  <div class="modal-protection flex --dir-col h-100">
    <div class="col">
       ${productHeader(productItem)}
    </div>
      ${type == "protection level" ? protectionAllMobile() : protectionHelmetMobile()};

  </div>
</div>`;
}

function protectionAllMobile() {
    return `
        <div class="modal__content">
  
        <div class="col desktop-1 mb-20">
          <h2 class="h1">NIJ Standard-0101.06 </h2>
        </div>
         <div class="switcher pos-r flex br--6">
                <button class="switcher__item active h3 fw-600" data-system="metric" >Metric</button>
                <button class="switcher__item h3 fw-600 " data-system="imperial">Imperial</button>
              </div>
        <div class="col desktop-4 ">

         
            
              <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                  Type IIA
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-1 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                         9mm FMJ RN
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                            8.0g</div><div class="imperial hide">
                            
                            124gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Conditions Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                            355m/s</div><div class="imperial hide">
                            
                            1165ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                          New Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                           373m/s</div><div class="imperial hide">
                            
                            1225ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Hits Per Panel at 0 Angel
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                     <div class="pb-20 border--bottom modal-protection__content">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                   Test
Bullet
                        </div>
                        <div>
                         .40S&W FMJ
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                            11.7g</div><div class="imperial hide">
                            
                            180gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Conditions Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                            325m/s</div><div class="imperial hide">
                            
                            1165ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                          New Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                           352m/s</div><div class="imperial hide">
                            
                            1155ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Hits Per Panel at 0 Angel
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                </div>
              </div>
              <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                  Type II
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-3 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                  Test
Bullet
                        </div>
                        <div>
                       9mm FMJ RN
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                            8.0g</div><div class="imperial hide">
                            
                            124gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Conditions Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                          
379m/s</div><div class="imperial hide">
                            
                            1245ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                          New Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                           398m/s</div><div class="imperial hide">
                            
                          1305ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Hits Per Panel at 0 Angel
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                
                </div>
              </div>
               <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                  Type IIIA
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                         Test
Bullet
                        </div>
                        <div>
                        
.357 Magnum
JSP
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           10.2g</div><div class="imperial hide">
                            
                           158gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Conditions Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                            408m/s</div><div class="imperial hide">
                            
                          1340ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                          New Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                           436m/s</div><div class="imperial hide">
                            
                            1430ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Hits Per Panel at 0 Angel
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
       Test
Bullet
                        </div>
                        <div>
                        .357 SIG
FMJ FN
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                            8.1g</div><div class="imperial hide">
                            
                           125gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Conditions Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                            430m/s</div><div class="imperial hide">
                            
                            1410ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                          New Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                           448m/s</div><div class="imperial hide">
                            
                          1470ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Hits Per Panel at 0 Angel
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                     <div class="pb-20 border--bottom modal-protection__content ">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
            Test
Bullet
                        </div>
                        <div>
                       
.44 Magnum
SJHP
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           15.6g</div><div class="imperial hide">
                            
                           240gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Conditions Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                           408m/s</div><div class="imperial hide">
                            
                       1340ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                          New Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                           436m/s</div><div class="imperial hide">
                            
                          1430ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Hits Per Panel at 0 Angel
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                </div>
              </div>
               <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                  Type III
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-4 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                     Test
Bullet
                        </div>
                        <div>
                    7.62mm
NATO FMJ
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                          9.6g</div><div class="imperial hide">
                            
                            147gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Conditions Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                          
847m/s</div><div class="imperial hide">
                            
                         2780ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                          New Armor Test Velocity*
                        </div>
                        <div >
                      -
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Hits Per Panel at 0 Angel
                        </div>
                        <div>
                     6
                            </div>
                    </div>
                    </div>
                
                </div>
              </div>
               <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                 Type IV
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-5 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                    Test
Bullet
                        </div>
                        <div>
                 
0.30CALIBER
M2AP
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                          10.8g</div><div class="imperial hide">
                            
                           166gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Conditions Armor Test Velocity*
                        </div>
                        <div>
                       <div class="metric">
                          
878m/s</div><div class="imperial hide">
                            
                        2880ft/s</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                          New Armor Test Velocity*
                        </div>
                        <div>
                      -
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Hits Per Panel at 0 Angel
                        </div>
                        <div>
                    1 to 6
                            </div>
                    </div>
                    </div>
                
                </div>
              </div>
           

      
          
         



        </div>
    
    






    </div>
    `
}

function protectionAll() {
    return `
     <div class="modal__content">
    <div class="col">
      <h2 class="h1 mb-20">NIJ Standard-0101.06 </h2>
    </div>
    <div class="modal-grid modal-grid__section ">




      <div class="col mb-40">
        <div class="table table-protection">
          <div class="table__row flex border--bottom">
            <div class="table__cell">
              <div class="switcher pos-r flex br--6">
                <button class="switcher__item active h3 fw-600" data-system="metric">g, m</button>
                <button class="switcher__item h3 fw-600 " data-system="imperial">in, oz</button>
              </div>
            </div>
            <div class="table__cell">
              Weapon Type
            </div>
          
            <div class="table__cell">
             Test Bullet
            </div>   
             <div class="table__cell">
              Bullet Mass
            </div>
            <div class="table__cell">
              Conditions Armor Test Velocity*
            </div>
            <div class="table__cell">
              New Armor Test Velocity*
            </div>
            <div class="table__cell">
              Hits Per Panel at 0 Angel
            </div>


          </div>
         
          <div class="table__row  flex border--bottom">
            <div class="table__cell">
              IIA
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-1 "></span>
              </div>
               <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>
            </div>
            <div class="table__cell --dir-col">

              <div class="table__row">
               9mm FMJ RN
              </div>
              <div class="table__row">
                .40S&W FMJ

              </div>
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                    8.0g 
                  </div>
                  <div class="imperial hide">
                     124gr
                  </div>
              </div>
               <div class="table__row">
                  <div class="metric">
                    11.7g
                  </div>
                  <div class="imperial hide">
                     180gr
                  </div>
              </div>
            </div>
            <div class="table__cell --dir-col">
               <div class="table__row">
                  <div class="metric">
                    355m/s
                  </div>
                  <div class="imperial hide">
                     1165ft/s
                  </div>
              </div>
              

               <div class="table__row">
                  <div class="metric">
                    325m/s
                  </div>
                  <div class="imperial hide">
                    1065ft/s
                  </div>
              </div>
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
                  <div class="metric">
                    373m/s
                  </div>
                  <div class="imperial hide">
                    1225ft/s
                  </div>
              </div>
               <div class="table__row">
                  <div class="metric">
                    352m/s
                  </div>
                  <div class="imperial hide">
                   1155ft/s
                  </div>
              </div>
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
                4
              </div>
              <div class="table__row">
                4

              </div>
            </div>
          </div>
          <div class="table__row  flex border--bottom">
            <div class="table__cell">
              II
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-3 "></span>
              </div>
              
            </div>
            <div class="table__cell --dir-col">

            
              <div class="table__row">
               9mm
FMJ RN

              </div>
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                    8.0g 
                  </div>
                  <div class="imperial hide">
                     124gr
                  </div>
              </div>
             
            </div>
            <div class="table__cell --dir-col">
               <div class="table__row">
                  <div class="metric">
                    379m/s
                  </div>
                  <div class="imperial hide ">
                     1245ft/s
                  </div>
              </div>
              
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
                  <div class="metric">
                   398m/s
                  </div>
                  <div class="imperial hide">
                    1305ft/s
                  </div>
              </div>
             
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
                4
              </div>
         
            </div>
          </div>
           <div class="table__row  flex border--bottom">
            <div class="table__cell">
              IIIA
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>
               <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div> <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>
            </div>
            <div class="table__cell --dir-col">

              <div class="table__row">
              
.357 Magnum
JSP
              </div>
              <div class="table__row">
                .357 SIG
FMJ FN

              </div> <div class="table__row">
             
.44 Magnum
SJHP

              </div>
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                    10.2g
                  </div>
                  <div class="imperial hide">
                    158gr
                  </div>
              </div>
               <div class="table__row">
                  <div class="metric">
                8.1g
                  </div>
                  <div class="imperial hide">
                    125gr
                  </div>
              </div><div class="table__row">
                  <div class="metric">
                  15.6g
                  </div>
                  <div class="imperial hide">
                     240gr
                  </div>
              </div>
            </div>
            <div class="table__cell --dir-col">
             <div class="table__row">
                  <div class="metric">
                  408m/s
                  </div>
                  <div class="imperial hide">
                    1340ft/s
                  </div>
              </div>
               <div class="table__row">
                  <div class="metric">
                    430m/s
                  </div>
                  <div class="imperial hide">
                     1410ft/s
                  </div>
              </div>
              

               <div class="table__row">
                  <div class="metric">
                    408m/s
                  </div>
                  <div class="imperial hide">
                    1340ft/s
                  </div>
              </div>
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
                  <div class="metric">
                   436m/s
                  </div>
                  <div class="imperial hide">
                    1430ft/s
                  </div>
              </div>
               <div class="table__row">
                  <div class="metric">
                    448m/s
                  </div>
                  <div class="imperial hide">
                  1470ft/s
                  </div>
              </div><div class="table__row">
                  <div class="metric">
                    436m/s

                  </div>
                  <div class="imperial hide">
                 1430ft/s
                  </div>
              </div>
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
                4
              </div>
              <div class="table__row">
                4

              </div> <div class="table__row">
                4

              </div>
            </div>
          </div>
           <div class="table__row  flex border--bottom">
            <div class="table__cell">
             III
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-4 "></span>
              </div>
              
            </div>
            <div class="table__cell --dir-col">

            
              <div class="table__row">
              7.62mm
NATO FMJ

              </div>
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                  9.6g

                  </div>
                  <div class="imperial hide">
                  147gr
                  </div>
              </div>
             
            </div>
            <div class="table__cell --dir-col">
               <div class="table__row">
                  <div class="metric">
                    847m/s

                  </div>
                  <div class="imperial hide">
                    2780ft/s
                  </div>
              </div>
              
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
                  -
              </div>
             
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
                6
              </div>
         
            </div>
          </div>
           <div class="table__row  flex border--bottom">
            <div class="table__cell">
            IV
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-5 "></span>
              </div>
              
            </div>
            <div class="table__cell --dir-col">

            
              <div class="table__row">
            
0.30CALIBER
M2AP

              </div>
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                 10.8g


                  </div>
                  <div class="imperial hide">
              166gr
                  </div>
              </div>
             
            </div>
            <div class="table__cell --dir-col">
               <div class="table__row">
                  <div class="metric">
                   878m/s


                  </div>
                  <div class="imperial hide">
                 2880ft/s
                  </div>
              </div>
              
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row ">
                  -
              </div>
             
            </div>
            <div class="table__cell --dir-col">
              <div class="table__row">
              1 to 6
              </div>
         
            </div>
          </div>

        </div>
      </div>





    </div>






  </div>
    `
}

function protectionHelmet() {
    return `
     <div class="modal__content">
    <div class="col">
      <h2 class="h1">NIJ Standard-0106.01</h2>
    </div>
    <div class="modal-grid modal-grid__section ">




      <div class="col mb-40">
        <div class="table table-protection">
          <div class="table__row flex border--bottom">
            <div class="table__cell">
              <div class="switcher pos-r flex br--6">
                <button class="switcher__item active h3 fw-600" data-system="metric">g, m</button>
                <button class="switcher__item h3 fw-600 " data-system="imperial">in, oz</button>
              </div>
            </div>
            <div class="table__cell">
              Weapon Type
            </div>
          
            <div class="table__cell">
             Test Bullet
            </div>   
             <div class="table__cell">
              Bullet Mass
            </div>
            <div class="table__cell">
          Required Bullet Velocity
            </div>
            <div class="table__cell">
        Velocity
Required Fair Hits Per Helmet Part
            </div>


          </div>
          <div class="table__row  flex border--bottom">
            <div class="table__cell">
              I
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>
               <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>
            </div>
            <div class="table__cell --dir-col">

              <div class="table__row">
            22 LRHV
Lead
              </div>
              <div class="table__row">
                38 Special
RN Lead

              </div>
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                    2.6 g

                  </div>
                  <div class="imperial hide">
                    50 gr
                  </div>
              </div>
               <div class="table__row">
                  <div class="metric">
                    10.2 g

                  </div>
                  <div class="imperial hide">
                     158 gr
                  </div>
              </div>
            </div>
            <div class="table__cell --dir-col">
               <div class="table__row">
                  <div class="metric">
                    320 ± 12m/s

                  </div>
                  <div class="imperial hide">
                    1050 ± 40ft/s
                  </div>
              </div>
              

               <div class="table__row">
                  <div class="metric">
                   259 ± 15m/s

                  </div>
                  <div class="imperial hide">
                    850 ± 50ft/s
                  </div>
              </div>
            </div>
          
            <div class="table__cell --dir-col">
              <div class="table__row">
                4
              </div>
              <div class="table__row">
                4

              </div>
            </div>
          </div>
          <div class="table__row  flex border--bottom">
            <div class="table__cell">
              IIA
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>  <div class="table__row">
                <span class="icon-gun-1 "></span>
              </div>
              
            </div>
            <div class="table__cell --dir-col">

            
              <div class="table__row">
            357 Magnum
JSP

              </div>  <div class="table__row">
          9mm
FMJ

              </div>
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                    10.2 g
                  </div>
                  <div class="imperial hide">
                 158 gr 
                  </div>
              </div>
              <div class="table__row">
                  <div class="metric">
                    8.2 g

                  </div>
                  <div class="imperial hide">
                   124 gr 
                  </div>
              </div>
             
            </div>
            <div class="table__cell --dir-col">
               <div class="table__row">
                  <div class="metric">
                    381 ± 15m/s
                  </div>
                  <div class="imperial hide ">
                   1250 ± 50ft/s
                  </div>
              </div><div class="table__row">
                  <div class="metric">
                    332 ± 15m/s
                  </div>
                  <div class="imperial hide ">
                     1090 ± 50ft/s
                  </div>
              </div>
              
            </div>
   
            <div class="table__cell --dir-col">
              <div class="table__row">
                4
              </div>   <div class="table__row">
                4
              </div>
         
            </div>
          </div>
           <div class="table__row  flex border--bottom">
            <div class="table__cell">
              II
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>
               <div class="table__row">
                <span class="icon-gun-1 "></span>
              </div> 
              
            </div>
            <div class="table__cell --dir-col">

              <div class="table__row">
              
357 Magnum
JSP
              </div>
              <div class="table__row">
            9mm
FMJ

              </div> 
          
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                    10.2g
                  </div>
                  <div class="imperial hide">
                    158gr
                  </div>
              </div>
               <div class="table__row">
                  <div class="metric">
                8.0g
                  </div>
                  <div class="imperial hide">
                    124gr
                  </div>
              </div>
            </div>
            <div class="table__cell --dir-col">
             <div class="table__row">
                  <div class="metric">
                 425 ± 15 m/s
                  </div>
                  <div class="imperial hide">
                1395 ± 50 ft/s
                  </div>
              </div>
               <div class="table__row">
                  <div class="metric">
                   358 ± 15m/s
                  </div>
                  <div class="imperial hide">
                 1175 ± 50ft/s
                  </div>
              </div>
              

            </div>
        
            <div class="table__cell --dir-col">
              <div class="table__row">
                4
              </div>
              <div class="table__row">
                4

              </div>
            </div>
          </div>
           <div class="table__row  flex border--bottom">
            <div class="table__cell">
             IIIA
            </div>
            <div class="table__cell --dir-col">


              <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>   <div class="table__row">
                <span class="icon-gun-2 "></span>
              </div>
              
            </div>
            <div class="table__cell --dir-col">

            
              <div class="table__row">
          357 SIG FMJ
FN

              </div><div class="table__row">44 Magnum
SJHP


              </div>
            
            </div> 
            <div class="table__cell --dir-col">

              <div class="table__row">
                  <div class="metric">
                8.1 g


                  </div>
                  <div class="imperial hide">
                  125 gr
                  </div>
              </div>   <div class="table__row">
                  <div class="metric">
              15.6 g


                  </div>
                  <div class="imperial hide">
                  240 gr
                  </div>
              </div>
             
            </div>
            <div class="table__cell --dir-col">
               <div class="table__row">
                  <div class="metric">
                    448 ± 15 m/s

                  </div>
                  <div class="imperial hide">
                 1469 ± 50 ft/s
                  </div>
              </div> <div class="table__row">
                  <div class="metric">
                436 ± 15m/s

                  </div>
                  <div class="imperial hide">
                1430 ± 50ft/s
                  </div>
              </div>
              
            </div>

             <div class="table__cell --dir-col">
              <div class="table__row">
                4
              </div>    <div class="table__row">
                4
              </div>
         
            </div>
          </div>
      

        </div>
      </div>





    </div>






  </div>
    `
}

function protectionHelmetMobile() {
    return `
        <div class="modal__content">
  
        <div class="col desktop-1 mb-20">
          <h2 class="h1 mb-20">NIJ Standard-0106.01 </h2> 
        </div>
         <div class="switcher pos-r flex br--6">
                <button class="switcher__item active h3 fw-600" data-system="metric">Metric</button>
                <button class="switcher__item h3 fw-600 " data-system="imperial">Imperial</button>
              </div>
        <div class="col desktop-4 ">

         
            
              <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                  Type I
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                         22 LRHV
Lead
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           2.6 g</div><div class="imperial hide">
                            
                           50 gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Required Bullet Velocity
                        </div>
                        <div>
                       <div class="metric">
                           320 ± 12m/s</div><div class="imperial hide">
                            
                            1050 ± 40ft/s</div>
                            </div>
                    </div>
            
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Fair Hits Per Helmet Part
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                       38 Special
RN Lead
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           10.2 g</div><div class="imperial hide">
                            
                           158 gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Bullet Velocity
                        </div>
                        <div>
                       <div class="metric">
                         259 ± 15m/s</div><div class="imperial hide">
                            
                        850 ± 50ft/s</div>
                            </div>
                    </div>
            
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Fair Hits Per Helmet Part
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                    
                    
                </div>
              </div>
              <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                  Type IIA
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                        357 Magnum
JSP
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           10.2 g</div><div class="imperial hide">
                            
                           158 gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Required Bullet Velocity
                        </div>
                        <div>
                       <div class="metric">
                           381 ± 15m/s</div><div class="imperial hide">
                            
                            1250 ± 50ft/s</div>
                            </div>
                    </div>
            
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Fair Hits Per Helmet Part
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-1 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                      9mm
FMJ
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           8.2 g</div><div class="imperial hide">
                            
                           124 gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Bullet Velocity
                        </div>
                        <div>
                       <div class="metric">
                         332 ± 15m/s</div><div class="imperial hide">
                            
                      1090 ± 50ft/s</div>
                            </div>
                    </div>
            
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Fair Hits Per Helmet Part
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                    
                    
                </div>
              </div>
              <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                  Type II
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                        357 Magnum
JSP
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           10.2 g</div><div class="imperial hide">
                            
                           158 gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Required Bullet Velocity
                        </div>
                        <div>
                       <div class="metric">
                           425 ± 15 m/s</div><div class="imperial hide">
                            
                            1395 ± 50 ft/s</div>
                            </div>
                    </div>
            
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Fair Hits Per Helmet Part
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-1 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                      9mm
FMJ
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           8.0 g</div><div class="imperial hide">
                            
                           124 gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Bullet Velocity
                        </div>
                        <div>
                       <div class="metric">
                        358 ± 15m/s</div><div class="imperial hide">
                            
                     1175 ± 50ft/s</div>
                            </div>
                    </div>
            
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Fair Hits Per Helmet Part
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                    
                    
                </div>
              </div>
              <div class="modal-protection__item  border--top border-black">
                <div class="flex py-20 w-100 --align-center --just-between" data-protect-smooth>
                <div class="h3 fw-600">
                  Type IIIA
                </div>
                <div class="triangle"></div>
                </div>
                <div class="modal-protection__item-wrapper">
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                       
357 SIG FMJ
FN
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           8.1 g</div><div class="imperial hide">
                            
                           125 gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                           Required Bullet Velocity
                        </div>
                        <div>
                       <div class="metric">
                           448 ± 15 m/s</div><div class="imperial hide">
                            
                            1469 ± 50 ft/s</div>
                            </div>
                    </div>
            
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Fair Hits Per Helmet Part
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                     <div class="pb-20 border--bottom modal-protection__content mb-20">
                    <div class="modal-protection__info txt--1">
                        <div class=" fw-700 mb-5">
                        Weapon Type
                        </div>
                        <div>
                          <span class="icon-gun-2 icon-30"></span>
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                        Test
Bullet
                        </div>
                        <div>
                      44 Magnum
SJHP
</div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                            Bullet Mass
                        </div>
                        <div>
                       <div class="metric">
                           15.6 g</div><div class="imperial hide">
                            
                           240 gr</div>
                            </div>
                    </div>
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Bullet Velocity
                        </div>
                        <div>
                       <div class="metric">
                   436 ± 15m/s</div><div class="imperial hide">
                            
                     1430 ± 50ft/s</div>
                            </div>
                    </div>
            
                    <div class="modal-protection__info txt--1">
                        <div class="fw-700 mb-5">
                      Required Fair Hits Per Helmet Part
                        </div>
                        <div>
                     4
                            </div>
                    </div>
                    </div>
                    
                    
                </div>
              </div>
         
           

      
          
         



        </div>
    
    






    </div>
    `
}

function renderGalleyImages(allImages) {
    let fragment = '';
    allImages.forEach(item => {
        if (!item) return;
        fragment += `
  <div class="photos__item br--16 pos-r">
    <div class="image">
<!--      <img src="${item.img || item.main}" alt="prodct photo">-->
${item.img || item.main}
    </div>
    <div class="photos__label pos-a ">
  
    </div>
  </div>
 `


    });
    return fragment;

}

function galleryModal() {
    const {allImages} = product;
    return `
  <div class="col modal__body ">

<div class="modal-gallery flex --dir-col h-100">
  <div class="col">
    ${productHeader(productItem)}
  </div>
  <div class="modal__content">

    <div class="modal-grid modal-grid__section tabs" data-tabs="galerry">
      <div class="col">

        <div class="tabs__nav flex w-100 mb-20">
          <button class="h1 fw-600 mr-20 active tabs__btn" data-tab="images">
            <div class="title">
              Images
            </div>
            <div class="quantity">${allImages.length}</div>

          </button>
<!--          <button class="h1 fw-600 mr-20 tabs__btn" data-tab="videos">-->

<!--            <div class="title">-->
<!--              Videos-->
<!--            </div>-->
<!--            <div class="quantity">8</div>-->
<!--          </button>-->

        </div>

      </div>
      <div class="tabs__body ">

        <div class="tabs__content show" data-tab="images">
          <div class="col mb-40">
            <div class="modal-gallery__content photos">

                ${renderGalleyImages(allImages)}

            </div>




          </div>
        </div>
<!--        <div class="tabs__content " data-tab="videos">-->
<!--          <div class="col mb-40">-->
<!--            <div class="modal-gallery__video">-->
<!--              <div class="video br&#45;&#45;16">-->
<!--                <iframe width="560" height="315" src="https://www.youtube.com/embed/BXJw3LKd7Ms"-->
<!--                  title="YouTube video player" -->
<!--                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"-->
<!--                  allowfullscreen></iframe>-->
<!--              </div>-->


<!--            </div>-->

<!--          </div>-->
<!--        </div>-->


      </div>

    </div>
  </div>
</div></div>`;
}

function techModal(product) {
    const {tech} = product;
    if (!tech) return
    let fragment = '';
    let tableContent = renderTechTable(product);
    if (matchMedia("(max-width: 767px)").matches) {
        tableContent = renderTechTableMobile(product);
    }
    tech.forEach(item => {
        let techItem = '';
        for (let value of item) {
            const {title, content, is_color} = value;
            const isColor = is_color[0];
            const titleEl = title ? ` <h3 class="mb-10 h2">${title}</h3>` : '';
            let colorWrapper = ''
            if (isColor.toLowerCase() == 'yes') {
                colorWrapper = `
              <div class="tech-specs__colors flex mb-10">
              ${renderColors(product)}
              </div>
           `
            }

            techItem += ` <div class="tech-specs__item mb-20">
            ${titleEl}
            ${colorWrapper}
            ${content}
            </div>`

        }

        fragment += `
           <div class="modal-subgrid__item mb-20">

          ${techItem}

          </div>
        `
    })
    return `
  
<div class="col desktop-5 wide-6 modal__body ">
<div class="modal-tech flex --dir-col h-100">
  <div class="col">
    ${productHeader(productItem)}
  </div>
  <div class="modal__content">
    <div class="modal-grid modal-grid__section border--bottom">
      <div class="col desktop-1 mb-20">
        <h2 class="h1">Tech specs </h2>
      </div>
      <div class="col desktop-4">

        <div class=" modal-subgrid">
        ${fragment}
      
        </div>



      </div>
    </div>
     ${tableContent}






  </div>
</div>
</div>
  `;
}

function renderTableCell(title, subtitle) {
    if (subtitle) {
        return `
        <div class="table__cell --wrap" data-system-item>
                  <span>${title}</span> <span class="ml-5"></span>
                  <div class="text-color__black--60 w-100 fw-500">${subtitle}</div>
                </div>
        `
    }
    ;
    return ` <div class="table__cell" data-system-item>
                  <span>${title}</span> <span class="ml-5"></span>
                </div>`
}

function renderTechTable(product) {
    const {tableTech} = product;
    if (!tableTech) return;

    let tabNav = '';
    let tabContent = ''
    tableTech.forEach(item => {
        const {metric, imperial, description} = item;
        let name = item.table_name.toLowerCase().split(' ').join('');
        if (name.indexOf('/') > 0) {
            name = name.split('/').join('');
        }
        let tabHeader = '';
        let tabRow = '';
        let tabDescr = ''
        if (description) {
            tabDescr = `<div class="text-color__black--60 mt-20">${description}</div>`
        }
        tabNav += `<button class="h1 fw-600 mr-20 tabs__btn" data-tab="${name}">
            <div class="title">
              ${item.table_name}
            </div>
<!--            <div class="quantity">46</div>-->

          </button>`


        item.table_header.forEach(headerItem => {
            const {title, subtitle} = headerItem
            tabHeader += renderTableCell(title, subtitle);
        })
        item.table_row.forEach(rowItem => {
            let tableCell = ''
            let row = Object.values(rowItem)
            row.forEach(cell => {
                for (let el of cell) {
                    tableCell += renderTableCell(el.text)
                }
            })
            tabRow += `
             <div class="table__row  flex border--bottom">
            ${tableCell}
            </div>
            `

        })
        tabContent += `  <div class="tabs__content" data-tab="${name}">
          <div class="col mb-40">
            <div class="table">
              <div class="table__row flex border--bottom">
                <div class="table__cell">
                    <div class="switcher pos-r flex br--6 ${!metric || !imperial ? 'none' : ''}">
                        <button class="switcher__item active h3 fw-600" data-system="metric" data-metric="${metric}">Metric</button>
                        <button class="switcher__item h3 fw-600 " data-system="imperial" data-imperial="${imperial}">Imperial</button>
                    </div>
                </div>
              ${tabHeader}
             


              </div>
                ${tabRow}
                ${tabDescr}
           
            </div>
          </div>
        </div>`
    })


    return `<div class="modal-grid modal-grid__section tabs" data-tabs="tech">
      <div class="col">

        <div class="tabs__nav flex w-100 mb-20">
            ${tabNav}
      
        </div>

      </div>
      <div class="tabs__body ">

      ${tabContent}
   



      </div>
    </div>`
}

function renderTechTableMobile(product) {
    const {tableTech} = product;
    let tabNav = '';
    let tabContent = ''
    tableTech.forEach(item => {

        const {metric, imperial} = item;
        let name = item.table_name.toLowerCase().split(' ').join('');
        tabNav += `<button class="h1 fw-600 mr-20 tabs__btn" data-tab="${name}">
            <div class="title">
              ${item.table_name}
            </div>
<!--            <div class="quantity">46</div>-->
          </button>`
        let tabItem = '';
        item.table_header.forEach((headerItem, j) => {
            let tableCell = ''
            if (headerItem.title) {

                item.table_row.forEach((rowItem) => {
                    let row = Object.values(rowItem)
                    row.forEach(cell => {
                        if (!cell[j + 1]) return;
                        tableCell += ` <div class="table-item__cell mb-20">
                    <div class="fw-700 mb-5">
                      ${cell[0].text}
                    </div>
                    <div data-system-item> <span>${cell[j + 1].text}</span><span class="ml-5"></span></div>
                  </div>`
                    })
                })
                tabItem += `<div class="table-item w-100 flex --dir-col">
                <div class="table-item__header  flex --align-center --just-between">
                  <div class="h2 fw-600">
                    ${headerItem.title}
                  </div>
                  <button class="table-item__btn">
                    <svg class="icon">
                      <use xlink:href="#dropdown"></use>
                    </svg>
                  </button>
                </div>
                <div class="table-item__content flex --just-between">
                    ${tableCell}
                </div>
              </div>`
            } else {
                item.table_row.forEach((rowItem, i) => {
                    let row = Object.values(rowItem)
                    row.forEach(cell => {
                        if (!cell[j + 1]) return;
                        tableCell += ` <div class="table-item__cell w-100 mb-20 flex --just-between">
                    <div class="fw-700 mb-5">
                      ${cell[0].text}
                    </div>
                    <div data-system-item> <span>${cell[1].text}</span> <span class="ml-5"></span></div>
                  </div>`
                    })
                })
                tabItem += `<div class="table-item w-100 flex --dir-col">
           
                <div class="--wrap flex ">
                   ${tableCell}
                </div>
              </div>`
            }
        })
        tabContent += `

<div class="tabs__content " data-tab="${name}">
 <div class="switcher pos-r flex br--6 mb-20">
              <button class="switcher__item active h3 fw-600 " data-system="metric" data-metric="${metric}">Metric</button>
              <button class="switcher__item h3 fw-600 " data-system="imperial" data-imperial="${imperial}">Imperial</button>
            </div>
             ${tabItem}
        </div>`

    })


    return `      <div class="modal-grid modal-grid__section tabs tabs-tech" data-tabs="tech">
        <div class="col">
          
       <div class="tabs__nav flex w-100 mb-20">
            ${tabNav}
      
        </div>
       
        </div>
          <div class="tabs__body flex">
          <div class="col mb-40">

            ${tabContent}
          </div>

        </div>


      </div>`
}


function compareModal() {
    return `
  <div class="col desktop-5 wide-6 modal__body ">
<div class="modal-compare container">
      ${productHeader(productItem)}
  <div class="col  mb-20 flex --just-between">
    <h2 class="h1">Compare</h2>
    <div class="compare-section__nav swiper__nav">

      <button class="slider__prev-compare-modal" class="flex"><span class="arrow arrow--left">
          <span class="icon-arrow-right"></span>
        </span>
      </button>     
      <button class="slider__next-compare-modal"><span class="arrow ">
          <span class="icon-arrow-right"></span>
        </span></button>
    </div>
  </div>

  <div class="compare-section__wrapper">
  <div class="compare-section   h-100 w-100 flex" data-swiper="compare-modal">

<div>${renderCompareItemMain(product)}</div>

    <div class="swiper-wrapper">
     
     ${renderCompareItem(product)}

    </div>
  </div>
</div>
  


</div>

</div>


`;
}

function compareModalCatalog() {
    return `
  <div class="col desktop-5 wide-6 modal__body ">
<div class="modal-compare container">
      ${productHeader(productItem)}
  <div class="col  mb-20 flex --just-between">
    <h2 class="h1">Compare</h2>
    <div class="compare-section__nav swiper__nav">

      <button class="slider__prev-compare-modal" class="flex"><span class="arrow arrow--left">
          <span class="icon-arrow-right"></span>
        </span>
      </button>     
      <button class="slider__next-compare-modal"><span class="arrow ">
          <span class="icon-arrow-right"></span>
        </span></button>
    </div>
  </div>

  <div class="compare-section__wrapper">
  <div class="compare-section   h-100 w-100 flex" data-swiper="compare-modal">
    <div class="swiper-wrapper">
     
     ${renderCompareItem()}

    </div>
  </div>
</div>
  


</div>

</div>


`;
}

function renderCompareInfo(info) {
    let fragment = ''
    info.forEach(item => {
        const {field_name, field_value} = item
        fragment += ` <div class="list__item">
              <h3 class="mb-10">${field_name}</h3>
              <div class="flex  h5">
               ${field_value}
              </div>
            </div>`

    })
    return fragment;
}

function renderCompareItemMain(product = null) {
    if (!product) return ``;
    const {compare, productId} = product;
    const {title, img, info, price} = compare.find(el => el.productID == productId)

    return ` <div class="compare-item compare-item__main ">
        <div class="compare-item__content-scroll">
          <div class="image mb-10">
            <img src="${img}" alt="">
          </div>
          <div class="flex list --dir-col">
            <div class="h2 compare-item__header">
              ${title.split(' ')[0]}
            </div>
                ${renderCompareInfo(info)}
          </div>
        </div>
       <div class="compare-item__footer-fixed">
       <div class="compare-item__footer">
       <div class="pos-a shadow--up"></div>
          <div class="price h2 fw-600 mb-10 pos-r">
            ${price}
          </div>
            <button class="btn btn--outline " data-cart>Add to cart</button>
        </div>
</div>
      </div>`
}

function renderCompareItem(product = null) {
    let compareItems = null;
    if (product) {
        const {compare, productId} = product;
        compareItems = compare.filter(el => el.productID != productId);
    } else {
        compareItems = compare;
    }

    let fragment = '';
    compareItems.forEach(item => {
        const {title, img, info, price, link} = item;
        fragment += `<div class="compare-item ">
        <div class="compare-item__content-scroll">
          <a  href="${link}" class="image flex mb-10">
            <img src="${img}" alt="">
          </a>
          <div class="flex list --dir-col">
            <a href="${link}" class="h2 compare-item__header text-color__black txt-no-underline">
                  ${title.split(' ')[0]}
            </a>
            ${renderCompareInfo(info)}
        

          </div>
        </div>
<div class="compare-item__footer-fixed">
<div class=" compare-item__footer">
  <div class="pos-a shadow--up"></div>
          <div class="price h2 fw-600 mb-10 pos-r">
            ${price}
          </div>
          <a href="${link}" class="btn btn--outline "><span>Learn more</span></a>
        </div>
</div>
        
      </div>`
    })

    return fragment
}

function configurationModal() {


    return `

  <div class="col desktop-5 wide-6 modal__body ">
  <div class="modal-configuratations">
    <div class="modal__header flex --align-center border--bottom border--black">
      <button class="modal__close mr-10"data-close>
        <svg class="icon">
          <use xlink:href="#arrow"></use>
        </svg>
      </button>
  
  
      <div class="h1 fw-600">Set up Full protection bundle 1 </div>
  
  
    </div>
    <div class="modal__content">
      <div class="modal__section mb-2  modal-grid border--bottom border--black">
        <div class="col tablet-1 desktop-1 wide-1">
          <h2 class="h1 mb-20">Color</h2>
        </div>
        <div class="col tablet-3 desktop-4 wide-4">
          <div class="product-item product-item__color product-item--line br--16">
  
            <div class="flex --just-between  --align-center mb-10">
  
              <div>Color</div>
  
  
  
  
  
              <button class="flex --align-center product-item__modal-triger">
                <span>Details</span>
  
                <span class="arrow arrow--left">
                  <span class="icon-arrow-right"></span>
                </span>
              </button>
            </div>
            <div class="colors flex scroll--y">
              <button class="colors__triger br--6">
                <div class="image"><img
                    src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_0976_edit-2-1024x1024.png"
                    alt="">
                </div>
              </button>
              <button class="colors__triger br--6">
                <div class="image"><img
                    src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_0976_edit-b-1-1024x1024.png"
                    alt="">
                </div>
              </button>
              <button class="colors__triger br--6">
                <div class="image "><img
                    src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_0976_edit-2-1024x1024.png"
                    alt="">
                </div>
              </button>
              <button class="colors__triger br--6">
                <div class="image"><img
                    src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_0976_edit-b-1-1024x1024.png"
                    alt="">
                </div>
              </button>
  
            </div>
  
          </div>
          <!-- <div class="product-item__parameters"></div> -->
  
        </div>
  
      </div>
      <div class="modal__section modal-grid border--bottom border--black">
        <div class="col  desktop-1 wide-1">
          <h2 class="h1 mb-20">Other parameters</h2>
        </div>
        <div class="col tablet-4 desktop-4 wide-4">
  
          <div class="flex --wrap">
            <div class="col tablet-2 mb-20">
              <div class="product-item br--16">
                <div class="product-item--line border--bottom">
                  <div class="flex --just-between">
                    <div>
                      <div class="h2 fw-600">
                        FAS™ Full Armor System
                      </div>
  
                      <div class=" h2 fw-600 text-color__black--60">$1,134</div>
  
  
  
                    </div>
                    <div class="preview preview--48 image br--6 ">
                      <img src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_8987-Edit-3-1-480x480.png"
                        alt="">
                    </div>
  
                  </div>
                </div>
                <div class="product-item--line border--bottom">
                  <div class="flex --just-between  --align-center mb-10">
  
  
                    <div class="mr-5">Size</div>
  
  
  
  
  
  
                    <button class="flex --align-center product-item__modal-triger">
                      <span>Size calculator</span>
  
                      <span class="arrow arrow--left">
                        <span class="icon-arrow-right"></span>
                      </span>
                    </button>
                  </div>
                  <div class="product-item__buttons flex --align-center">
                    <button class="btn btn--outline  active">S/m</button>
                    <button class="btn btn--outline ">L/XL</button>
  
                  </div>
                </div>
                <div class="product-item--line ">
                  <div class="flex --just-between  --align-center mb-10">
                    <div class="mr-10">Protection level</div>
                    <button class="flex --align-center product-item__modal-triger">
                      <span>How to choose</span>
  
                      <span class="arrow arrow--left">
                        <span class="icon-arrow-right"></span>
                      </span>
                    </button>
                  </div>
                  <div class="product-item__buttons flex product-item__buttons--height-auto">
                    <button class="btn btn--outline active --dir-col">
                      <span>Type IIA</span>
                      <span>Included</span>
  
                    </button>
                    <button class="btn btn--outline  --dir-col">
                      <span>Type II</span>
                      <span>+$108</span>
  
                    </button>
                    <button class="btn btn--outline  --dir-col">
                      <span>Type IIIA</span>
                      <span>+$485</span>
  
                    </button>
  
                  </div>
                </div>
              </div>
            </div>
            <div class="col tablet-2 mb-20">
              <div class="product-item br--16">
                <div class="product-item--line border--bottom">
                  <div class="flex --just-between">
                    <div>
                      <div class="h2 fw-600">
                        FAS™ Full Armor System
                      </div>
  
                      <div class=" h2 fw-600 text-color__black--60">$1,134</div>
  
  
  
                    </div>
                    <div class="preview preview--48 image br--6 ">
                      <img src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_8987-Edit-3-1-480x480.png"
                        alt="">
                    </div>
  
                  </div>
                </div>
                <div class="product-item--line border--bottom">
                  <div class="flex --just-between  --align-center mb-10">
  
  
                    <div class="mr-5">Size</div>
  
  
  
  
  
  
                    <button class="flex --align-center product-item__modal-triger">
                      <span>Size calculator</span>
  
                      <span class="arrow arrow--left">
                        <span class="icon-arrow-right"></span>
                      </span>
                    </button>
                  </div>
                  <div class="product-item__buttons flex --align-center">
                    <button class="btn btn--outline  active">S/m</button>
                    <button class="btn btn--outline ">L/XL</button>
  
                  </div>
                </div>
                <div class="product-item--line ">
                  <div class="flex --just-between  --align-center mb-10">
                    <div class="mr-10">Protection level</div>
                    <button class="flex --align-center product-item__modal-triger">
                      <span>How to choose</span>
  
                      <span class="arrow arrow--left">
                        <span class="icon-arrow-right"></span>
                      </span>
                    </button>
                  </div>
                  <div class="product-item__buttons flex product-item__buttons--height-auto">
                    <button class="btn btn--outline active --dir-col">
                      <span>Type IIA</span>
                      <span>Included</span>
  
                    </button>
                    <button class="btn btn--outline  --dir-col">
                      <span>Type II</span>
                      <span>+$108</span>
  
                    </button>
                    <button class="btn btn--outline  --dir-col">
                      <span>Type IIIA</span>
                      <span>+$485</span>
  
                    </button>
  
                  </div>
                </div>
              </div>
            </div>
            <div class="col tablet-2 mb-20">
              <div class="product-item br--16">
                <div class="product-item--line border--bottom">
                  <div class="flex --just-between">
                    <div>
                      <div class="h2 fw-600">
                        FAS™ Full Armor System
                      </div>
  
                      <div class=" h2 fw-600 text-color__black--60">$1,134</div>
  
  
  
                    </div>
                    <div class="preview preview--48 image br--6 ">
                      <img src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_8987-Edit-3-1-480x480.png"
                        alt="">
                    </div>
  
                  </div>
                </div>
                <div class="product-item--line border--bottom">
                  <div class="flex --just-between  --align-center mb-10">
  
  
                    <div class="mr-5">Size</div>
  
  
  
  
  
  
                    <button class="flex --align-center product-item__modal-triger">
                      <span>Size calculator</span>
  
                      <span class="arrow arrow--left">
                        <span class="icon-arrow-right"></span>
                      </span>
                    </button>
                  </div>
                  <div class="product-item__buttons flex --align-center">
                    <button class="btn btn--outline  active">S/m</button>
                    <button class="btn btn--outline ">L/XL</button>
  
                  </div>
                </div>
                <div class="product-item--line ">
                  <div class="flex --just-between  --align-center mb-10">
                    <div class="mr-10">Protection level</div>
                    <button class="flex --align-center product-item__modal-triger">
                      <span>How to choose</span>
  
                      <span class="arrow arrow--left">
                        <span class="icon-arrow-right"></span>
                      </span>
                    </button>
                  </div>
                  <div class="product-item__buttons flex product-item__buttons--height-auto">
                    <button class="btn btn--outline active --dir-col">
                      <span>Type IIA</span>
                      <span>Included</span>
  
                    </button>
                    <button class="btn btn--outline  --dir-col">
                      <span>Type II</span>
                      <span>+$108</span>
  
                    </button>
                    <button class="btn btn--outline  --dir-col">
                      <span>Type IIIA</span>
                      <span>+$485</span>
  
                    </button>
  
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal__footer modal-configuratations__footer  shadow--up">
      <div class="flex --just-between --align-center --wrap">
        <div class="flex --align-center --wrap">
          <div class="mr-10 flex">
            <div class="preview mr-10 preview--48 image br--6 ">
              <img src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_8987-Edit-3-1-480x480.png" alt="">
            </div>
            <div class="preview mr-10 preview--48 image br--6 ">
              <img src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_8987-Edit-3-1-480x480.png" alt="">
            </div>
            <div class="preview mr-10 preview--48 image br--6 ">
              <img src="https://uarmprotection.com/wp-content/uploads/2020/07/IMG_8987-Edit-3-1-480x480.png" alt="">
            </div>
          </div>
          <div class="flex --dir-col name">
            <div class="h2 fw-600 ">
              Full protection bundle 1
            </div>
            <div class="flex --align-end">
              <div class="price text-color__black--60 flex --align-end mr-20">
                <div data-price-new="1134" class=" h2 fw-600 mr-5">$1,134</div>
                <s data-price-old="1260">$1,260</s>
  
              </div>
              <div>
                <div>Save $72</div>
              </div>
            </div>
          </div>
  
        </div>
        <div class="product-item__buttons flex --align-center">
          <button class="btn btn--paypal mr-10">
  
            <span></span>
  
  
          </button>
          <button class="btn btn--black " data-cart>
            Add to bag
  
          </button>
  
  
        </div>
      </div>
    </div>
  </div>
  </div>`;
}

function getAttributesScheme(attributes) {
    let info = [];
    for (let key in attributes) {
        if (key == 'pa_color') {
            info = [key, ...info];
        }
        if (key !== 'pa_cummerbund-size' && key !== 'pa_color') {
            info = [...info, key];
        }
    }
    return info;
}

function fixAttributeValue(attributeValue) {
    let value = '';
    value = attributeValue.charAt(0).toUpperCase() + attributeValue.slice(1);
    if (attributeValue.length < 4) {
        value = value.toUpperCase();
    }
    if (attributeValue.indexOf('_') > 0) {
        value = value.split("_").join(' ');
    }
    if (attributeValue.match(/[0-9]/) && attributeValue.match(/[0-9]/).index > 0) {
        let number = attributeValue.match(/[0-9]/)[0];
        let j = '';
        for (let i = 1; i <= number; i++) {
            j += 'I';
        }
        value = value.split(`${number}`).join(`${j}`) + ' ';
        value = value.slice(0, -1) + value.slice(-1).toUpperCase();
    }
    return value;
}

function getAttributeName(value) {
    let name = ''
    switch (value) {
        case ('pa_color'): {
            name = 'Color';
            break;
        }
        case ('pa_size'): {
            name = 'Size';
            break;
        }
        case ('pa_cummerbund'): {
            name = 'Cummerbund';
            break;
        }
        case ('pa_protection-level'): {
            name = 'Protection level';
            break;
        }
        case ('type'): {
            name = 'Type';
            break;
        }
        case ('composite'): {
            name = 'Composite';
            break;
        }

    }
    return name;
}

function getAlternativePhotoPreview(item, product) {
    const {images: {photos}} = product;
    let imgItem = photos.find(el => el.slug == item.pa_color)
    if (imgItem) {
        return imgItem.colors[0].img
    }
}

function getAlternativeColorPattern(item, product) {
    const {attributes: {allAttributes}} = product;

    const patternParent = allAttributes.find(el => {
        for (let key in el) {
            if (key == 'pa_color') {
                return el
            }
        }
    })
    if (patternParent) {
        return patternParent.pa_color.values?.find(el => el.slug == item.pa_color).pattern;
    } else {
        return product.thumbnail
    }

}


function alternativesModal(product) {
    const {title, currency, images: {photos}} = product
    const {stock_status, price, attributes} = findVariation(getCurrentVariation());
    let photoPreview = '';
    let info = getAttributesScheme(attributes);
    let attributesInfo = ''

    info.forEach(item => {
        let name = getAttributeName(item);
        let value = findAttributeValue(attributes, item);
        attributesInfo += `<div class="compare-item--line color text-color__black--60">
              ${name}: ${value} 
            </div>`
        if (product.plate) {
            product.plate.forEach(productItem => {
                name = getAttributeName(productItem.name);
                if (name === 'Composite') {
                    let currentProductValue = productItem.links.find(el => el.id === product.productId);
                    if (currentProductValue) {
                        attributesInfo += `<div class="compare-item--line color text-color__black--60">
                        ${name}: ${currentProductValue.attrName}
                    </div>`
                    }
                }
            })
        }
    })
    let alternatives = '';
    getAlternatives().forEach(item => {
        let alternativeTitle = '';
        let img = ''
        if (product.plate) {
            img = item.thumbnail;
            let alternativesInfo = ''
            alternativeTitle = item.title;
            let chooseBtn = '';
            let altId = item.alternative.id;
            getAttributesScheme(item.alternative.attributes).forEach(itemAttr => {
                let name = getAttributeName(itemAttr);
                let value = findAttributeValue(item.alternative.attributes[itemAttr], itemAttr);
                if (attributes[itemAttr] == item.alternative.attributes[itemAttr]) {
                    alternativesInfo += `<div class="compare-item--line color text-color__black--60">
                        ${name}: ${value}
                    </div>`
                } else {
                    name = attributes[itemAttr] !== item.alternative.attributes[itemAttr] ? `Different ${name.toLowerCase()}` : `${name}`;
                    alternativesInfo += `<div class="compare-item--line color text-color__black--60">
                <div class="label fw-600 --just-start --align-center flex-inline label--light-gray">${name}: ${value}</div>
            </div>`
                }

                product.plate.forEach(productItem => {
                    name = getAttributeName(productItem.name);
                    let currentProductValue = productItem.links.find(el => el.id === item.id);
                    if (currentProductValue) {
                        alternativesInfo += `<div class="compare-item--line color text-color__black--60">
                <div class="label fw-600 --just-start --align-center flex-inline label--light-gray">Different ${name}: ${currentProductValue.attrName}</div>
            </div>`
                    }


                })


            });
            if (item.id) {

                chooseBtn = `<a href="${item.href}" class="btn  btn--black  mt-10">Choose</a>`
            } else if (item.productID) {

                chooseBtn = `<a href="${item.link}" class="btn  btn--black  mt-10">Choose</a>`
                alternativesInfo += `<div class="compare-item--line compare-item--line_empty ">
                                         
                                        </div>`
            } else {

                chooseBtn = `<button class="btn  btn--black  mt-10" data-choose-alternative>Choose</button>`
                getAlternatives().forEach(plateItem => {
                    if (plateItem.productId) {
                        plateItem.plate.forEach(productItem => {
                            let name = getAttributeName(productItem.name);
                            if (name === 'Composite') {
                                let currentProductValue = productItem.links.find(el => el.id === product.productId);
                                if (currentProductValue) {
                                    alternativesInfo += `<div class="compare-item--line color text-color__black--60">
                                            Composite: ${currentProductValue.attrName}
                                        </div>`
                                }
                            }
                        })


                    }

                })

            }


            alternatives += `<div class="swiper-slide">
          <div class="compare-item " data-price="${item.alternative.price}" data-alternative-id="${altId}">  <div class="image mb-10">
    ${img}
              ${item.productID ? '<div class="label label--light-gray label--blur pos-a"> Other product</div>' : ''}
               
            </div>
            <div class="h2  fw-600 flex --dir-col">
              <div class="mb-auto">${alternativeTitle}</div>
              <div class="text-color__black--60">${currency}${item.alternative.price}</div>
            </div>
            <div class="compare-item--line">
              <div class="label  --just-start --align-center flex-inline label--green"> <svg class="icon mr-5"><use xlink:href="#check"></use></svg><span>In stock</span></div>
            </div>
            ${alternativesInfo}
            ${chooseBtn}
            </div>
            </div>`


        } else {
            if (item.id) {
                const {price} = item;
                let img = '';
                const {images: {photos}} = product
                let attributesInfo = ''
                let alternativeTitle = item.id ? title : item.title;
                getAttributesScheme(item.attributes).forEach(itemAttr => {
                    let name = getAttributeName(itemAttr);
                    let value = findAttributeValue(item.attributes, itemAttr);
                    if (attributes[itemAttr] == item.attributes[itemAttr]) {
                        attributesInfo += `<div class="compare-item--line color text-color__black--60">
                        ${name}: ${value}
                    </div>`
                    } else {
                        name = attributes[itemAttr] !== item.attributes[itemAttr] ? `Different ${name.toLowerCase()}` : `${name}`;
                        attributesInfo += `<div class="compare-item--line color text-color__black--60">
                <div class="label fw-600 --just-start --align-center flex-inline label--light-gray">${name}: ${value}</div>
            </div>`
                    }
                });
                let chooseBtn = `<button class="btn  btn--black  mt-10" data-choose-alternative>Choose</button>`

                if (photos && photos.length > 0) {
                    if (getAlternativePhotoPreview(item.attributes, product)) {
                        img = getAlternativePhotoPreview(item.attributes, product);
                    } else {
                        img = getAlternativeColorPattern(item.attributes, product);
                    }
                } else {
                    img = getAlternativeColorPattern(item.attributes, product);
                }
                alternatives += `<div class="swiper-slide">
          <div class="compare-item " data-price="${price}" data-alternative-id="${item.id}">  <div class="image mb-10">
             ${img}
            </div>
            <div class="h2  fw-600 flex --dir-col">
              <div class="mb-auto">${alternativeTitle}</div>
              <div class="text-color__black--60">${currency}${price}</div>
            </div>
            <div class="compare-item--line">
              <div class="label  --just-start --align-center flex-inline label--green"> <svg class="icon mr-5"><use xlink:href="#check"></use></svg><span>In stock</span></div>
            </div>
            ${attributesInfo}
            ${chooseBtn}
            </div>
            </div>`

            } else {
                let attributesInfo = ''
                let img = '';
                const {images: {photos}} = item;
                getAttributesScheme(item.alternative.attributes).forEach(itemAttr => {
                    Object.keys(attributes).forEach(objAttr => {
                        if (objAttr == itemAttr) {
                            let name = getAttributeName(itemAttr);
                            let value = findAttributeValue(item.alternative.attributes, itemAttr);
                            if (attributes[itemAttr] == item.alternative.attributes[itemAttr]) {
                                attributesInfo += `<div class="compare-item--line color text-color__black--60">
                        ${name}: ${value}
                    </div>`
                            } else {
                                name = attributes[itemAttr] !== item.alternative.attributes[itemAttr] ? `Different ${name.toLowerCase()}` : `${name}`;
                                attributesInfo += `<div class="compare-item--line color text-color__black--60">
                <div class="label fw-600 --just-start --align-center flex-inline label--light-gray">${name}: ${value}</div>
            </div>`
                            }
                        }
                    })
                })
                if (photos && photos.length > 0) {
                    if (getAlternativePhotoPreview(item.alternative.attributes, item)) {
                        img = getAlternativePhotoPreview(item.alternative.attributes, item);
                    } else {
                        img = getAlternativeColorPattern(item.alternative.attributes, item);
                    }
                } else {
                    img = getAlternativeColorPattern(item.alternative.attributes, item);
                }
                alternatives += `<div class="swiper-slide">
            <div class="compare-item ">
            <div class="image mb-10">
             ${img}
               <div class="label label--light-gray label--blur pos-a"> Other product</div>
            </div>
              <div class="h2  fw-600 flex --dir-col">
            <div class="mb-auto">${item.title}</div>
              <div class="text-color__black--60">${item.price}</div>
            </div>
            <div class="compare-item--line">
              <div class="label  --just-start flex-inline label--green"> <svg class="icon mr-5"><use xlink:href="#check"></use></svg><span>In stock</span></div>
            </div>
            ${attributesInfo}
            <a href="${item.link}" class="btn  btn--black  mt-10">Choose</a>
            </div></div>`
            }
        }

    });
    if (photos && photos.length > 0) {
        if (getAlternativePhotoPreview(attributes, product)) {
            photoPreview = getAlternativePhotoPreview(attributes, product);
        } else {
            photoPreview = getAlternativeColorPattern(attributes, product);
        }
    } else {
        photoPreview = getAlternativeColorPattern(attributes, product);
    }
    return `
  <div class="col desktop-5 wide-6 modal__body ">
<div class="modal-alternatives container">
  <div class="modal__header  flex --align-center border--bottom border--black mb-20">
    <button class="modal__close mr-10"data-close>
      <svg class="icon">
        <use xlink:href="#arrow"></use>
      </svg>
    </button>
    <div class="h1 fw-600">Alternatives </div>
  </div>
  <div class="modal__content">
 
      <div class="mb-20 flex --just-between">
        <h2 class="h1">Alternatives for ${title}</h2>
        <div class="flex swiper__nav">
          <button class="slider__prev-alternative-modal"><span class="arrow  arrow--left">
              <span class="icon-arrow-right"></span>
            </span></button>
          <button class="slider__next-alternative-modal" class="flex"><span class="arrow">
              <span class="icon-arrow-right"></span>
            </span>
          </button>
        </div>
      </div>
      <div class="flex" data-alternative-wrapper>
        <div class="compare-item compare-item__main ">
            <div class="image mb-10">
              ${photoPreview}
            </div>
             <div class="h2  fw-600 flex --dir-col">
              <div class="mb-auto">${title}</div>
              <div class="text-color__black--60">${currency}${price}</div>

            </div>
            <div class="compare-item--line">
             <div class="label --just-start  flex-inline  label--warning">${stock_status}</div>
           
            </div>
            ${attributesInfo}
        <button class="btn btn--outline mt-10 " data-close>Keep this</button>
       
          


        </div>
        <div data-swiper="alternative-modal" class="overflow  w-100">
            <div class="swiper-wrapper">
                ${alternatives}
           
            </div>
      </div>
    </div>
  </div>
</div>
</div>`;
}

function setupModal(productItem) {
    const modalProduct = findProductItem(productItem.dataset[productItem.dataset.subproduct], productItem.dataset.subproduct);
    const {currency, price, title, regularPrice, link} = modalProduct;
    const thumbnail = productItem.dataset.productThumbnail
    return `
  <div class="col tablet-3 desktop-2 wide-3 ">
<div class="modal__body modal-config h-100">
    <div class="modal__header mb-20 flex --align-center border--bottom border-black">
                <button class="modal__close mr-10" data-close>
                  <svg class="icon">
                    <use xlink:href="#arrow"></use>
                  </svg>
                </button>
              
            
                <h2>Set up product</h2>
            
        
        
          </div>
    
        <div class="product-item__main br--16" data-product-thumbnail="${thumbnail}" data-product-id="${modalProduct.productId}">
        <div class="scroll__wrapper">

                <div class="product-item__title product-item--line flex  --just-between">
    <a href="${link}" class="h1 text-color__black txt-no-underline" data-product-title>${title}</a>
    </div>
                <div class="product-item__price   product-item--line border--bottom flex --just-between --align-center">

        <div class="price text-color__black--60 flex --align-end">
            <div data-price-new="" data-variation-price='' data-product-quantity="1" data-product-price="${Math.round((+price))}" class=" h1 fw-600 ">
          ${currency}${Math.round((+price))}
            </div>
            <s  data-price-old="${regularPrice}">${regularPrice !== '' && price != regularPrice ? Math.round((+regularPrice)) : ''}</s>

        </div>
        <div class="dropdown">
                <div class="dropdown__btn">
                    <div class="installment border--top flex --align-center" >
                        <div class="mr-5" >or <span data-installment>$283</span> x 4 mo</div> <span class="installment__logo">
                         <svg class="icon">
                                                                                               <use xlink:href="#paypal"></use>
                                                                                           </svg>
                    </span>
                    </div>
                </div>
                <div class="dropdown__content br--6 shadow--drop">

                    <ul class="installment__list">
                        <li class="installment__item flex border--bottom --just-between --align-center" data-installment-name="PayPal">
                            <span>PayPal Credit </span>
                            <span class="installment__logo">
                   <svg class="icon">
                                                                                               <use xlink:href="#paypal"></use>
                                                                                           </svg>
              </span>
                        </li>

                        <li class="installment__item flex border--bottom --just-between --align-center" data-installment-name="Sezzle">
                            <span>Sezzle</span>
                            <span class="installment__logo image">

                                                        <img src="assets/img/sezzle.png" alt="">

                            </span>
                        </li>
                        <li class="installment__item flex border--bottom --just-between --align-center" data-installment-name="Klarna">
                            <span>Klarna</span>
                            <span class="icon-klarna-logo installment__logo"></span>
                        </li>
                        <li class="installment__item flex --align-center" data-installment-name="Learn">
                            <a href="#"><span class="mr-5">Learn more</span>
                                <span class="icon-arrow-right icon-8"></span></a>
                        </li>
                    </ul>
                </div>
            </div>
          

    </div>
  
<!--                <div class="product-item__labels product-item&#45;&#45;line flex border&#45;&#45;bottom">-->
<!--             -->
<!--        <div class="label mr-5  label&#45;&#45;light-gray">10% Military + 15% Christmas Sale</div>-->
<!--        <div class="label mr-5 label&#45;&#45;outline-green">+$113 Cashback</div>-->


<!--    </div>-->
                <div class="product-item__attributes" data-attributes>
            
                
                
          
               </div>   </div>
                <div class="modal__footer shadow--up flex --align-center --just-between">
      <button class="btn btn--outline" data-close>Back to shopping</button>
      <button class="btn btn--black" data-cart>Add to bag</button>
  
        </div>
    </div>
          
  
</div>

</div>`;
}


function renderVariationsAttributesMain(renderAttributes, productItem, parentEl) {
    let {images: {photos}, isHelmet, plate} = productItem;

    const parent = parentEl.querySelector('.product-item__attributes');
    const fragment = document.createDocumentFragment();
    for (let item of renderAttributes) {
        for (let key in item) {
            let {attrName, label, values} = item[key];
            const div = document.createElement('div');
            div.classList = `product-item__${label.toLowerCase().split(' ').join('-')} product-item--line border--bottom`;
            const divHeader = document.createElement('div');
            divHeader.classList = 'flex --just-between  --align-center mb-10';
            divHeader.innerHTML = `<div class="mr-10">${label}</div>`;

            if (renderLabelButton(label)) {
                const modalTrigger = document.createElement('button');
                modalTrigger.classList = "flex --align-center product-item__modal-triger";
                modalTrigger.dataset.modal = label.toLowerCase();
                if (isHelmet) {
                    modalTrigger.dataset.modal = 'protection helmet'
                }
                modalTrigger.innerHTML = `
                          <span class="mr-5">${renderLabelButton(label)}</span>
                          <span class="icon-arrow-right icon-12"></span>`;
                divHeader.appendChild(modalTrigger);
            }
            div.appendChild(divHeader);

            if (values.length == 1) {
                div.classList.add('none')
            }

            div.appendChild(renderButtons(attrName, label, values, photos));

            if (attrName === 'pa_color') {
                fragment.prepend(div)
            } else {
                fragment.appendChild(div)
            }

        }
    }

    parent.appendChild(fragment)
}


function findProductItem(id, slug) {

    return product[slug].find(el => el && el.productId == +id)
}

function renderReportModal() {
    const productVariant = product?.variations.find(item => item.id === +getElement('.product-item__main[data-product-id]').dataset.productId);
    return `
<div class="modal-pickup modal__body col">
  <div class="modal__header mb-15 ">
    <div class="flex --align-center mb-15">
        <button class="modal__close mr-24" data-close>
            <svg class="icon">
                        <use xlink:href="#arrow"></use>
            </svg>
                    </button>
                   <h2 class="h1 ">Out of stock</h2> 
                   </div>
  <div class="modal__content">
 <form class="pickup__form report-form">
              <input type="hidden" name="sku" value="${productVariant.sku}">


   <div style="margin-bottom: 2.4rem" class="form__item">
            <input type="text" id="report_name" name="name">
            <label for="report_name">Name <span class="text-color__error">*</span></label>
            <div class="form__message text-color__error pos-a txt--2 mt-5"></div>
      </div>
       <div class="form__item  ">
            <input type="email" id="report_email" name="email">
            <label for="report_email">Email <span class="text-color__error">*</span></label>
            <div class="form__message text-color__error pos-a txt--2 mt-5"></div>
      </div>
       <div class="modal__footer shadow--up flex --align-center --just-between">
      <button type="submit" class="btn btn--black w-100" >Notify when available</button>

        </div>
    </form>
  </div>
       <div class="modal__footer none shadow--up flex --align-center --just-between">
  
      <button data-close="" class="btn btn--black w-100" >Back</button>
        </div>
</div>`;
}


export {Modal};
export {
    colorModal,
    sizeModal,
    protectionModal,
    protectionModalEvents,
    protectionModalMobile,
    fixAttributeValue,
    getAlternativeColorPattern,
    getAlternativePhotoPreview
};
